import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import MespuanReklamBasvuru from "./MespuanReklamBasvuru";
import MespuanReklamBasvurulari from "./MespuanReklamBasvurulari";

const DEFAULT_API_BASE =
  "https://panel.haymestasarim.com/api/mespuan";

const LANGUAGE_OPTIONS = [
  { value: "tr", label: "Türkçe", short: "TR" },
  { value: "en", label: "English", short: "EN" },
  { value: "de", label: "Deutsch", short: "DE" },
];

const TRANSLATIONS = {
  en: {
    "Günlük giriş görevi": "Daily login task",
    "Instagram kampanya kodu": "Instagram campaign code",
    "Web sitesi kampanya kodu": "Website campaign code",
    "Anket katılımı": "Survey participation",
    "İçerik okuma": "Read content",
    "QR ziyaret": "QR visit",
    "Profil tamamlama": "Complete profile",
    "Telefon doğrulama": "Phone verification",
    Alışveriş: "Purchase",
    "Üye daveti": "Member referral",
    Herkes: "Everyone",
    "Belirli kurum": "Specific institution",
    "Belirli ülke": "Specific country",
    "Belirli şehir": "Specific city",
    "Belirli grup": "Specific group",
    "Yeni kullanıcılar": "New users",
    "Tüm hareketler": "All movements",
    "İlk kayıt ödülü": "Welcome reward",
    "Günlük giriş": "Daily login",
    "Görev ödülü": "Task reward",
    "Video ödülü": "Video reward",
    "Yönetici düzeltmesi": "Admin adjustment",
    "MesPuan kullanımı": "MesPuan usage",
    "Genel Bakış": "Overview",
    Görevler: "Tasks",
    "Sponsor Videoları": "Sponsor Videos",
    "Marketplace İndirimleri": "Marketplace Discounts",
    Cüzdanlar: "Wallets",
    Hareketler: "Movements",
    "Risk Merkezi": "Risk Center",
    "Sistem Ayarları": "System Settings",
    Aktif: "Active",
    Pasif: "Inactive",
    Planlandı: "Scheduled",
    "Süresi doldu": "Expired",
    "Stokta yok": "Sold out",
    Donduruldu: "Frozen",
    Engellendi: "Blocked",
    İncelemede: "Pending review",
    Çözüldü: "Resolved",
    "Oturum bilgisi bulunamadı. Yeniden giriş yapın.":
      "Session information was not found. Please sign in again.",
    "Sunucudan geçerli bir yanıt alınamadı.":
      "A valid response could not be received from the server.",
    "MesPuan işlemi tamamlanamadı.":
      "The MesPuan operation could not be completed.",
    "Görev güncellendi.": "Task updated.",
    "Yeni görev oluşturuldu.": "New task created.",
    "Sponsor kampanyası güncellendi.": "Sponsor campaign updated.",
    "Sponsor kampanyası oluşturuldu.": "Sponsor campaign created.",
    "Görev arşivlendi.": "Task archived.",
    "Kampanya arşivlendi.": "Campaign archived.",
    "MesPuan sistem ayarları kaydedildi.":
      "MesPuan system settings saved.",
    "Puan miktarı sıfır olamaz.": "Point amount cannot be zero.",
    "En az 10 karakterlik işlem gerekçesi yazın.":
      "Enter an operation reason of at least 10 characters.",
    "Cüzdan düzeltme hareketi kaydedildi.":
      "Wallet adjustment recorded.",
    "Yönetici güvenlik incelemesi": "Administrator security review",
    "Cüzdan donduruldu.": "Wallet frozen.",
    "Cüzdan yeniden aktifleştirildi.": "Wallet reactivated.",
    "Engelleme gerekçesini yazın:": "Enter the blocking reason:",
    "Çözüm notunu yazın:": "Enter the resolution note:",
    "Risk incelemesi sonucunda hesap engellendi.":
      "The account was blocked following a risk review.",
    "Yönetici tarafından incelendi ve çözüldü.":
      "Reviewed and resolved by an administrator.",
    "Riskli hesap engellendi.": "Risky account blocked.",
    "Risk kaydı çözüldü.": "Risk record resolved.",
    "Bu kaydı pasife alıp arşivlemek istiyor musunuz?":
      "Do you want to deactivate and archive this record?",
    "MESYAT DİJİTAL YÖNETİM PANELİ":
      "MESYAT DIGITAL MANAGEMENT PANEL",
    "MesYat Para Yönetimi": "MesYat Money Management",
    "Görevleri, sponsor videolarını, MesPuan cüzdanlarını ve güvenlik hareketlerini tek merkezden yönetin.":
      "Manage tasks, sponsor videos, MesPuan wallets and security activity from one center.",
    "Kurum kapsamı": "Institution scope",
    "Boş = tüm sistem": "Empty = entire system",
    "Kurum ID": "Institution ID",
    "Yükleniyor...": "Loading...",
    "Verileri Yenile": "Refresh Data",
    "Kapalı devre sadakat sistemi": "Closed-loop loyalty system",
    "Güvenli cüzdan yapısı": "Secure wallet architecture",
    "MesPuan nakit değildir, transfer edilemez ve cari hesaba yazılmaz. Bütün hareketler denetlenebilir kayıtlardır.":
      "MesPuan is not cash, cannot be transferred and is not posted to current accounts. Every movement is auditable.",
    "İşlem tamamlanamadı": "Operation failed",
    "Tekrar dene": "Try again",
    "MesPuan ekosisteminin güncel performansı ve güvenlik özeti.":
      "Current performance and security overview of the MesPuan ecosystem.",

      "Dolaşımdaki MesPuan": "MesPuan in Circulation",
    "Sistem Genelindeki MesPuan": "System-wide MesPuan",
    "Kurum Ağındaki MesPuan": "Institution Network MesPuan",
    "Aktif Cüzdan": "Active Wallets",


    "Bugünkü Aktif Kullanıcı": "Active Users Today",
    "Bugün Tamamlanan Görev": "Tasks Completed Today",
    "Bugün Kazanılan": "Earned Today",
    "Bugün Kullanılan": "Spent Today",
    "Açık Risk Kaydı": "Open Risk Records",
    "Kısıtlı Cüzdan": "Restricted Wallets",
    "Son 7 Günlük Hareket": "Last 7 Days",
    "Kazanılan ve kullanılan MesPuan karşılaştırması":
      "Earned versus spent MesPuan",
    "En Çok Tamamlanan Görevler": "Most Completed Tasks",
    "Katılım ve dağıtılan puan performansı":
      "Participation and distributed point performance",
    "Henüz görev verisi yok": "No task data yet",
    "Henüz hareket verisi yok": "No movement data yet",
    "MesPuan kazanıldığında günlük grafik burada oluşur.":
      "The daily chart will appear here when MesPuan is earned.",
    "İlk görev oluşturulduğunda performansı burada görünür.":
      "Performance will appear here after the first task is created.",
    tamamlama: "completions",
    "Görev Yönetimi": "Task Management",
    "Instagram kodu, anket, içerik ve doğrulanmış sistem görevlerini yönetin.":
      "Manage Instagram codes, surveys, content and verified system tasks.",
    "Yeni Görev Oluştur": "Create New Task",
    "Tüm görev türleri": "All task types",
    "Tüm durumlar": "All statuses",
    Görev: "Task",
    Tür: "Type",
    Ödül: "Reward",
    Katılım: "Participation",
    Dağıtılan: "Distributed",
    Durum: "Status",
    "Açıklama yok": "No description",
    "Görev bulunamadı": "No tasks found",
    "Filtreyi değiştirin veya yeni bir MesPuan görevi oluşturun.":
      "Change the filter or create a new MesPuan task.",
    "Sponsor Video Yönetimi": "Sponsor Video Management",
    "Sponsor videolarını, izleme haklarını ve puan bütçelerini yönetin.":
      "Manage sponsor videos, viewing rights and point budgets.",
    "Sponsor Videosu Ekle": "Add Sponsor Video",
    "Sponsor kampanyası bulunamadı": "No sponsor campaign found",
    "İlk sponsor videosunu ekleyerek MesPuan kampanyasını başlatın.":
      "Start a MesPuan campaign by adding the first sponsor video.",
    "MesYat sponsor kampanyası": "MesYat sponsor campaign",
    Tamamlanan: "Completed",
    "Günlük hak": "Daily allowance",
    "İzleme oranı": "Viewing rate",
    "Puan bütçesi": "Point budget",
    Sınırsız: "Unlimited",
    Düzenle: "Edit",
    Arşivle: "Archive",
    "İndirim Yönetimi": "Discount Management",
    "MesPuan karşılığında kullanılabilecek ürün ve hizmet indirimlerini yönetin.":
      "Manage product and service discounts redeemable with MesPuan.",
    "Yeni İndirim Oluştur": "Create New Discount",
    "İndirim bulunamadı": "No discount found",
    "İlk Marketplace indirimini oluşturarak MesPuan kullanımını başlatın.":
      "Create the first Marketplace discount to enable MesPuan redemption.",
    "İndirim başlığı": "Discount title",
    "Ürün/Hizmet adı": "Product/Service name",
    "Ürün referansı": "Product reference",
    "Gerekli MesPuan": "Required MesPuan",
    "İndirim türü": "Discount type",
    "Sabit tutar": "Fixed amount",
    "Yüzde": "Percentage",
    "İndirim değeri": "Discount value",
    "Para birimi": "Currency",
    "Azami indirim oranı": "Maximum discount rate",
    "Kampanya stoğu": "Campaign stock",
    "Kullanıcı başı limit": "Per-user limit",
    "İndirim aktif": "Discount active",
    "İndirimi Düzenle": "Edit Discount",
    "Yeni Marketplace İndirimi": "New Marketplace Discount",
    "MesPuan kullanım koşullarını, indirim değerini ve kampanya stoğunu belirleyin.":
      "Set MesPuan redemption terms, discount value and campaign stock.",
    "İndirimi Güncelle": "Update Discount",
    "İndirimi Oluştur": "Create Discount",
    "İndirim güncellendi.": "Discount updated.",
    "Yeni indirim oluşturuldu.": "New discount created.",
    "İndirim arşivlendi.": "Discount archived.",
    Kullanım: "Redemptions",
    Stok: "Stock",
    "Cüzdan Yönetimi": "Wallet Management",
    "Kullanıcı bakiyelerini ve güvenlik durumlarını inceleyin.":
      "Review user balances and security statuses.",
    Dondurulmuş: "Frozen",
    Engellenmiş: "Blocked",
    Kullanıcı: "User",
    Bakiye: "Balance",
    "Toplam Kazanç": "Lifetime Earned",
    Kullanılan: "Spent",
    Seri: "Streak",
    Düzelt: "Adjust",
    Aktifleştir: "Reactivate",
    Dondur: "Freeze",
    "Cüzdan bulunamadı": "No wallet found",
    "Arama ölçütlerinize uygun MesPuan cüzdanı yok.":
      "No MesPuan wallet matches your search criteria.",
    "MesPuan Hareketleri": "MesPuan Movements",
    "Değiştirilemeyen puan hareketlerini işlem ve kullanıcı bazında inceleyin.":
      "Review immutable point movements by transaction and user.",
    İşlem: "Transaction",
    Kurum: "Institution",
    Tutar: "Amount",
    "Son Bakiye": "Final Balance",
    Tarih: "Date",
    Genel: "General",
    "Hareket bulunamadı": "No movement found",
    "Seçilen filtrelerde MesPuan hareketi bulunmuyor.":
      "No MesPuan movements match the selected filters.",
    "Şüpheli hareketleri inceleyin, çözün veya riskli cüzdanları engelleyin.":
      "Review suspicious activity, resolve records or block risky wallets.",
    Risk: "Risk",
    "Açıklama bulunmuyor.": "No description available.",
    "Genel sistem": "General system",
    "Hesabı Engelle": "Block Account",
    "Risk kaydı bulunamadı": "No risk record found",
    "Seçilen durumda incelenecek risk kaydı yok.":
      "There are no risk records to review in the selected status.",
    "MesPuan kazanma kurallarını ve güvenlik sınırlarını yönetin.":
      "Manage MesPuan earning rules and security limits.",
    "Ayarlar yükleniyor": "Loading settings",
    "MesPuan sistem ayarları hazırlanıyor.":
      "Preparing MesPuan system settings.",
    "Kurumsal Puan Kimliği": "Corporate Point Identity",
    "Panelde ve kullanıcı ekranlarında gösterilecek puan adını belirleyin.":
      "Set the point name shown in the panel and user screens.",
    "Puan adı": "Point name",
    "Puan sembolü": "Point symbol",
    "Temel Puan Kuralları": "Core Point Rules",
    "Kullanıcıların otomatik kazanacağı puanları belirleyin.":
      "Set the points users earn automatically.",
    "Günlük giriş ödülü": "Daily login reward",
    "Sınırlar ve Geçerlilik": "Limits and Validity",
    "Günlük kazanç, video ve puan geçerlilik sınırları.":
      "Daily earning, video and point validity limits.",
    "Günlük kazanma sınırı": "Daily earning limit",
    "Puan geçerlilik süresi": "Point validity period",
    "Günlük azami video": "Maximum daily videos",
    "Risk dondurma puanı": "Risk freeze threshold",
    "Seri toleransı": "Streak grace period",
    "Hareket saklama süresi": "Movement retention period",
    gün: "days",
    video: "videos",
    "Sistem ve Güvenlik": "System and Security",
    "Ana sistem durumunu ve doğrulama kurallarını yönetin.":
      "Manage core system status and verification rules.",
    "MesPuan sistemi aktif": "MesPuan system active",
    "Kapalı olduğunda yeni puan kazanılamaz.":
      "No new points can be earned while disabled.",
    "Sponsor videoları aktif": "Sponsor videos active",
    "Kurum içi sponsor kampanyalarını açar.":
      "Enables internal sponsor campaigns.",
    "AdMob kampanyaları aktif": "AdMob campaigns active",
    "Yalnızca sunucu tarafı SSV doğrulaması kuruluysa açın.":
      "Enable only when server-side SSV verification is configured.",
    "Günlük seri aktif": "Daily streak active",
    "Ardışık giriş günlerini takip eder.":
      "Tracks consecutive login days.",
    "Telefon doğrulaması gerekli": "Phone verification required",
    "Uygun görevlerde doğrulanmış telefon ister.":
      "Requires a verified phone for eligible tasks.",
    "Aynı cihazda çoklu hesap koruması":
      "Multiple-account device protection",
    "Şüpheli çoklu hesap kullanımını işaretler.":
      "Flags suspicious multiple-account usage.",
    "Açık rıza zorunlu": "Explicit consent required",
    "Ödüllü içerik öncesinde kullanıcı onayı ister.":
      "Requires user consent before rewarded content.",
    "Değiştirilemeyen güvenlik kuralları":
      "Immutable security rules",
    "Kullanıcılar arası transfer, nakde çevirme ve cari hesaba aktarma her zaman kapalıdır.":
      "User transfers, cash conversion and current-account posting are always disabled.",
    "Kaydediliyor...": "Saving...",
    "Ayarları Kaydet": "Save Settings",
    "Görevi Düzenle": "Edit Task",
    "Yeni MesPuan Görevi": "New MesPuan Task",
    "Mobil uygulamada gösterilecek görevin kurallarını belirleyin.":
      "Define the rules for the task shown in the mobile app.",
    "Görev başlığı": "Task title",
    "Görev açıklaması": "Task description",
    "Görev türü": "Task type",
    "Kazandırılacak MesPuan": "MesPuan reward",
    "Günlük katılım sınırı": "Daily participation limit",
    "Toplam katılım sınırı": "Total participation limit",
    "Toplam puan bütçesi": "Total point budget",
    "Boş = sınırsız": "Empty = unlimited",
    "Doğrulama yöntemi": "Verification method",

    "Sunucu tarafından": "Server verified",
    "Sayfa oturumuyla": "Page session",
    "Kampanya koduyla": "Campaign code",
    "Kullanıcı tamamlamasıyla": "User completion",
    "Sayfada kalma süresi (saniye)":
      "Required page time (seconds)",
    "Hedef kitle": "Target audience",

    "Hedef değer": "Target value",
    "Kurum, ülke, şehir veya grup değeri":
      "Institution, country, city or group value",
    "Başlangıç tarihi": "Start date",
    "Bitiş tarihi": "End date",
    "Hedef bağlantı": "Destination URL",
    "Yeni kampanya kodu (isteğe bağlı)":
      "New campaign code (optional)",
    "Kampanya kodu": "Campaign code",
    "Kullanıcıya sorulacak metin": "Question shown to user",
    "Instagram paylaşımındaki kodu yazın":
      "Enter the code from the Instagram post",
    "Başarı mesajı": "Success message",
    "Görev tamamlandı. MesPuan hesabınıza eklendi.":
      "Task completed. MesPuan has been added to your account.",
    "Yalnızca bir kez tamamlanabilir": "Can be completed only once",
    "Görev aktif": "Task active",
    "Görevi Güncelle": "Update Task",
    "Görevi Oluştur": "Create Task",
    "Sponsor Videosunu Düzenle": "Edit Sponsor Video",
    "Yeni Sponsor Videosu": "New Sponsor Video",
    "Video süresini, ödülünü ve kampanya bütçesini tanımlayın.":
      "Define the video duration, reward and campaign budget.",
    "Kampanya başlığı": "Campaign title",
    "Sponsor/firma adı": "Sponsor/company name",
    Sağlayıcı: "Provider",
    "MesYat sponsor videosu": "MesYat sponsor video",
    "AdMob (SSV gerekli)": "AdMob (SSV required)",
    "Video bağlantısı": "Video URL",
    "Kapak resmi bağlantısı": "Thumbnail URL",
    "Video süresi (saniye)": "Video duration (seconds)",
    "Tamamlama oranı (%)": "Completion percentage (%)",
    "Video ödülü": "Video reward",
    "Günlük izleme hakkı": "Daily viewing allowance",
    "Toplam izlenme sınırı": "Total view limit",
    "Sponsor kampanyası aktif": "Sponsor campaign active",
    "Kampanyayı Güncelle": "Update Campaign",
    "Kampanyayı Oluştur": "Create Campaign",
    "Cüzdan Düzeltmesi": "Wallet Adjustment",
    "Cüzdanı Dondur": "Freeze Wallet",
    "Cüzdanı Aktifleştir": "Reactivate Wallet",
    "Puan miktarı": "Point amount",
    Referans: "Reference",
    "İsteğe bağlı işlem referansı": "Optional transaction reference",
    "İşlem gerekçesi": "Operation reason",
    "Denetim kaydı için ayrıntılı gerekçe yazın":
      "Enter a detailed reason for the audit record",
    Vazgeç: "Cancel",
    "İşleniyor...": "Processing...",
    "İşlemi Onayla": "Confirm Operation",
    Kazanılan: "Earned",
    Önceki: "Previous",
    Sonraki: "Next",
    ARA: "SEARCH",
    "Başlık, kullanıcı veya işlem ara...":
      "Search title, user or transaction...",
    Filtrele: "Filter",
    Kapat: "Close",
    kayıt: "records",
    Sayfa: "Page",

    "Onay Bekliyor":
      "Pending Approval",

    Reddedildi:
      "Rejected",

    "Onay Bekleyenler":
      "Pending Approval",

    "Reddedilenler":
      "Rejected Tasks",

    "Onaylanmış Görevler":
      "Approved Tasks",

    Onayla:
      "Approve",

    Reddet:
      "Reject",

    "Görevin ret gerekçesini yazın.":
      "Enter the reason for rejecting the task.",

    "Ret gerekçesi en az 5 karakter olmalıdır.":
      "The rejection reason must contain at least 5 characters.",

    "Bu görev mobil uygulamada yayınlanacaktır. Onaylıyor musunuz?":
      "This task will be published in the mobile application. Do you approve?",

    "Görev reddedildi.":
      "Task rejected.",

    "Görev onaylandı ve yayına alındı.":
      "Task approved and published.",

    "Görev merkez onayına gönderildi.":
      "Task submitted for central approval.",

    "Görev güncellendi ve yeniden merkez onayına gönderildi.":
      "Task updated and resubmitted for central approval.",
 "Görevi Onaya Gönder":
      "Submit Task for Approval",

    "Değişiklikleri Onaya Gönder":
      "Submit Changes for Approval",

    "Yönetici notu":
      "Administrator note",


  },
  de: {

    "Onay Bekliyor":
      "Freigabe ausstehend",


    "Görevi Onaya Gönder":
      "Aufgabe zur Freigabe senden",

    "Değişiklikleri Onaya Gönder":
      "Änderungen zur Freigabe senden",
    Reddedildi:
      "Abgelehnt",

    "Onay Bekleyenler":
      "Ausstehende Freigaben",

    "Reddedilenler":
      "Abgelehnte Aufgaben",

    "Onaylanmış Görevler":
      "Freigegebene Aufgaben",

    Onayla:
      "Freigeben",

    Reddet:
      "Ablehnen",

    "Görevin ret gerekçesini yazın.":
      "Geben Sie den Grund für die Ablehnung ein.",

    "Ret gerekçesi en az 5 karakter olmalıdır.":
      "Der Ablehnungsgrund muss mindestens 5 Zeichen enthalten.",

    "Bu görev mobil uygulamada yayınlanacaktır. Onaylıyor musunuz?":
      "Diese Aufgabe wird in der mobilen Anwendung veröffentlicht. Möchten Sie sie freigeben?",

    "Görev reddedildi.":
      "Aufgabe abgelehnt.",

    "Görev onaylandı ve yayına alındı.":
      "Aufgabe freigegeben und veröffentlicht.",

    "Görev merkez onayına gönderildi.":
      "Aufgabe zur zentralen Freigabe eingereicht.",

    "Görev güncellendi ve yeniden merkez onayına gönderildi.":
      "Aufgabe aktualisiert und erneut zur zentralen Freigabe eingereicht.",

    "Yönetici notu":
      "Administratorhinweis",

    "Günlük giriş görevi": "Tägliche Anmeldeaufgabe",
    "Instagram kampanya kodu": "Instagram-Kampagnencode",
    "Web sitesi kampanya kodu": "Website-Kampagnencode",
    "Anket katılımı": "Umfrageteilnahme",
    "İçerik okuma": "Inhalt lesen",
    "QR ziyaret": "QR-Besuch",
    "Profil tamamlama": "Profil vervollständigen",
    "Telefon doğrulama": "Telefonbestätigung",
    Alışveriş: "Einkauf",
    "Üye daveti": "Mitgliederempfehlung",
    Herkes: "Alle",
    "Belirli kurum": "Bestimmte Institution",
    "Belirli ülke": "Bestimmtes Land",
    "Belirli şehir": "Bestimmte Stadt",
    "Belirli grup": "Bestimmte Gruppe",
    "Yeni kullanıcılar": "Neue Benutzer",
    "Tüm hareketler": "Alle Bewegungen",
    "İlk kayıt ödülü": "Willkommensbonus",
    "Günlük giriş": "Tägliche Anmeldung",
    "Görev ödülü": "Aufgabenbonus",
    "Video ödülü": "Videobonus",
    "Yönetici düzeltmesi": "Admin-Korrektur",
    "MesPuan kullanımı": "MesPuan-Nutzung",
    "Genel Bakış": "Übersicht",
    Görevler: "Aufgaben",
    "Sponsor Videoları": "Sponsorvideos",
    "Marketplace İndirimleri": "Marketplace-Rabatte",
    Cüzdanlar: "Wallets",
    Hareketler: "Bewegungen",
    "Risk Merkezi": "Risikozentrum",
    "Sistem Ayarları": "Systemeinstellungen",
    Aktif: "Aktiv",
    Pasif: "Inaktiv",
    Planlandı: "Geplant",
    "Süresi doldu": "Abgelaufen",
    "Stokta yok": "Ausverkauft",
    Donduruldu: "Eingefroren",
    Engellendi: "Gesperrt",
    İncelemede: "In Prüfung",
    Çözüldü: "Gelöst",
    "Oturum bilgisi bulunamadı. Yeniden giriş yapın.":
      "Sitzungsdaten wurden nicht gefunden. Bitte erneut anmelden.",
    "Sunucudan geçerli bir yanıt alınamadı.":
      "Vom Server wurde keine gültige Antwort empfangen.",
    "MesPuan işlemi tamamlanamadı.":
      "Der MesPuan-Vorgang konnte nicht abgeschlossen werden.",
    "Görev güncellendi.": "Aufgabe aktualisiert.",
    "Yeni görev oluşturuldu.": "Neue Aufgabe erstellt.",
    "Sponsor kampanyası güncellendi.": "Sponsor-Kampagne aktualisiert.",
    "Sponsor kampanyası oluşturuldu.": "Sponsor-Kampagne erstellt.",
    "Görev arşivlendi.": "Aufgabe archiviert.",
    "Kampanya arşivlendi.": "Kampagne archiviert.",
    "MesPuan sistem ayarları kaydedildi.":
      "MesPuan-Systemeinstellungen gespeichert.",
    "Puan miktarı sıfır olamaz.": "Die Punktzahl darf nicht null sein.",
    "En az 10 karakterlik işlem gerekçesi yazın.":
      "Geben Sie eine Begründung mit mindestens 10 Zeichen ein.",
    "Cüzdan düzeltme hareketi kaydedildi.":
      "Wallet-Korrektur wurde gespeichert.",
    "Yönetici güvenlik incelemesi": "Sicherheitsprüfung durch Administrator",
    "Cüzdan donduruldu.": "Wallet wurde eingefroren.",
    "Cüzdan yeniden aktifleştirildi.": "Wallet wurde reaktiviert.",
    "Engelleme gerekçesini yazın:": "Sperrgrund eingeben:",
    "Çözüm notunu yazın:": "Lösungsnotiz eingeben:",
    "Risk incelemesi sonucunda hesap engellendi.":
      "Das Konto wurde nach der Risikoprüfung gesperrt.",
    "Yönetici tarafından incelendi ve çözüldü.":
      "Vom Administrator geprüft und gelöst.",
    "Riskli hesap engellendi.": "Risikokonto wurde gesperrt.",
    "Risk kaydı çözüldü.": "Risikoeintrag wurde gelöst.",
    "Bu kaydı pasife alıp arşivlemek istiyor musunuz?":
      "Möchten Sie diesen Eintrag deaktivieren und archivieren?",
    "MESYAT DİJİTAL YÖNETİM PANELİ":
      "MESYAT DIGITALES VERWALTUNGSPANEL",
    "MesYat Para Yönetimi": "MesYat Geldverwaltung",
    "Görevleri, sponsor videolarını, MesPuan cüzdanlarını ve güvenlik hareketlerini tek merkezden yönetin.":
      "Verwalten Sie Aufgaben, Sponsorvideos, MesPuan-Wallets und Sicherheitsaktivitäten zentral.",
    "Kurum kapsamı": "Institutionsbereich",
    "Boş = tüm sistem": "Leer = gesamtes System",
    "Kurum ID": "Institutions-ID",
    "Yükleniyor...": "Wird geladen...",
    "Verileri Yenile": "Daten aktualisieren",
    "Kapalı devre sadakat sistemi": "Geschlossenes Treuesystem",
    "Güvenli cüzdan yapısı": "Sichere Wallet-Struktur",
    "MesPuan nakit değildir, transfer edilemez ve cari hesaba yazılmaz. Bütün hareketler denetlenebilir kayıtlardır.":
      "MesPuan ist kein Bargeld, nicht übertragbar und wird nicht auf Kontokorrentkonten gebucht. Alle Bewegungen sind prüfbar.",
    "İşlem tamamlanamadı": "Vorgang fehlgeschlagen",
    "Tekrar dene": "Erneut versuchen",
    "MesPuan ekosisteminin güncel performansı ve güvenlik özeti.":
      "Aktuelle Leistungs- und Sicherheitsübersicht des MesPuan-Systems.",


    "Dolaşımdaki MesPuan": "MesPuan im Umlauf",
    "Sistem Genelindeki MesPuan": "MesPuan im Gesamtsystem",
    "Kurum Ağındaki MesPuan": "MesPuan im Institutionsnetzwerk",
    "Aktif Cüzdan": "Aktive Wallets",

    "Bugünkü Aktif Kullanıcı": "Heute aktive Benutzer",
    "Bugün Tamamlanan Görev": "Heute erledigte Aufgaben",
    "Bugün Kazanılan": "Heute verdient",
    "Bugün Kullanılan": "Heute verwendet",
    "Açık Risk Kaydı": "Offene Risikoeinträge",
    "Kısıtlı Cüzdan": "Eingeschränkte Wallets",
    "Son 7 Günlük Hareket": "Letzte 7 Tage",
    "Kazanılan ve kullanılan MesPuan karşılaştırması":
      "Vergleich von verdienten und verwendeten MesPuan",
    "En Çok Tamamlanan Görevler": "Meist erledigte Aufgaben",
    "Katılım ve dağıtılan puan performansı":
      "Teilnahme und verteilte Punkte",
    "Henüz görev verisi yok": "Noch keine Aufgabendaten",
    "Henüz hareket verisi yok": "Noch keine Bewegungsdaten",
    "MesPuan kazanıldığında günlük grafik burada oluşur.":
      "Das Tagesdiagramm erscheint, sobald MesPuan verdient wird.",
    "İlk görev oluşturulduğunda performansı burada görünür.":
      "Die Leistung erscheint hier nach der ersten Aufgabe.",
    tamamlama: "Abschlüsse",
    "Görev Yönetimi": "Aufgabenverwaltung",
    "Instagram kodu, anket, içerik ve doğrulanmış sistem görevlerini yönetin.":
      "Instagram-Codes, Umfragen, Inhalte und verifizierte Systemaufgaben verwalten.",
    "Yeni Görev Oluştur": "Neue Aufgabe erstellen",
    "Tüm görev türleri": "Alle Aufgabentypen",
    "Tüm durumlar": "Alle Status",
    Görev: "Aufgabe",
    Tür: "Typ",
    Ödül: "Bonus",
    Katılım: "Teilnahme",
    Dağıtılan: "Verteilt",
    Durum: "Status",
    "Açıklama yok": "Keine Beschreibung",
    "Görev bulunamadı": "Keine Aufgabe gefunden",
    "Filtreyi değiştirin veya yeni bir MesPuan görevi oluşturun.":
      "Filter ändern oder eine neue MesPuan-Aufgabe erstellen.",
    "Sponsor Video Yönetimi": "Sponsorvideo-Verwaltung",
    "Sponsor videolarını, izleme haklarını ve puan bütçelerini yönetin.":
      "Sponsorvideos, Ansichtsrechte und Punktebudgets verwalten.",
    "Sponsor Videosu Ekle": "Sponsorvideo hinzufügen",
    "Sponsor kampanyası bulunamadı": "Keine Sponsor-Kampagne gefunden",
    "İlk sponsor videosunu ekleyerek MesPuan kampanyasını başlatın.":
      "Starten Sie die MesPuan-Kampagne mit dem ersten Sponsorvideo.",
    "MesYat sponsor kampanyası": "MesYat Sponsor-Kampagne",
    Tamamlanan: "Abgeschlossen",
    "Günlük hak": "Tageslimit",
    "İzleme oranı": "Ansichtsquote",
    "Puan bütçesi": "Punktebudget",
    Sınırsız: "Unbegrenzt",
    Düzenle: "Bearbeiten",
    Arşivle: "Archivieren",
    "İndirim Yönetimi": "Rabattverwaltung",
    "MesPuan karşılığında kullanılabilecek ürün ve hizmet indirimlerini yönetin.":
      "Produkt- und Dienstleistungsrabatte für MesPuan verwalten.",
    "Yeni İndirim Oluştur": "Neuen Rabatt erstellen",
    "İndirim bulunamadı": "Kein Rabatt gefunden",
    "İlk Marketplace indirimini oluşturarak MesPuan kullanımını başlatın.":
      "Erstellen Sie den ersten Marketplace-Rabatt für die MesPuan-Nutzung.",
    "İndirim başlığı": "Rabatttitel",
    "Ürün/Hizmet adı": "Produkt-/Dienstleistungsname",
    "Ürün referansı": "Produktreferenz",
    "Gerekli MesPuan": "Erforderliche MesPuan",
    "İndirim türü": "Rabattart",
    "Sabit tutar": "Festbetrag",
    "Yüzde": "Prozent",
    "İndirim değeri": "Rabattwert",
    "Para birimi": "Währung",
    "Azami indirim oranı": "Maximaler Rabattsatz",
    "Kampanya stoğu": "Kampagnenbestand",
    "Kullanıcı başı limit": "Limit pro Benutzer",
    "İndirim aktif": "Rabatt aktiv",
    "İndirimi Düzenle": "Rabatt bearbeiten",
    "Yeni Marketplace İndirimi": "Neuer Marketplace-Rabatt",
    "MesPuan kullanım koşullarını, indirim değerini ve kampanya stoğunu belirleyin.":
      "MesPuan-Nutzung, Rabattwert und Kampagnenbestand festlegen.",
    "İndirimi Güncelle": "Rabatt aktualisieren",
    "İndirimi Oluştur": "Rabatt erstellen",
    "İndirim güncellendi.": "Rabatt aktualisiert.",
    "Yeni indirim oluşturuldu.": "Neuer Rabatt erstellt.",
    "İndirim arşivlendi.": "Rabatt archiviert.",
    Kullanım: "Einlösungen",
    Stok: "Bestand",
    "Cüzdan Yönetimi": "Wallet-Verwaltung",
    "Kullanıcı bakiyelerini ve güvenlik durumlarını inceleyin.":
      "Benutzersalden und Sicherheitsstatus prüfen.",
    Dondurulmuş: "Eingefroren",
    Engellenmiş: "Gesperrt",
    Kullanıcı: "Benutzer",
    Bakiye: "Saldo",
    "Toplam Kazanç": "Gesamtverdienst",
    Kullanılan: "Verwendet",
    Seri: "Serie",
    Düzelt: "Korrigieren",
    Aktifleştir: "Reaktivieren",
    Dondur: "Einfrieren",
    "Cüzdan bulunamadı": "Kein Wallet gefunden",
    "Arama ölçütlerinize uygun MesPuan cüzdanı yok.":
      "Kein MesPuan-Wallet entspricht den Suchkriterien.",
    "MesPuan Hareketleri": "MesPuan-Bewegungen",
    "Değiştirilemeyen puan hareketlerini işlem ve kullanıcı bazında inceleyin.":
      "Unveränderliche Punktebewegungen nach Vorgang und Benutzer prüfen.",
    İşlem: "Vorgang",
    Kurum: "Institution",
    Tutar: "Betrag",
    "Son Bakiye": "Endsaldo",
    Tarih: "Datum",
    Genel: "Allgemein",
    "Hareket bulunamadı": "Keine Bewegung gefunden",
    "Seçilen filtrelerde MesPuan hareketi bulunmuyor.":
      "Keine MesPuan-Bewegungen für die gewählten Filter.",
    "Şüpheli hareketleri inceleyin, çözün veya riskli cüzdanları engelleyin.":
      "Verdächtige Aktivitäten prüfen, lösen oder riskante Wallets sperren.",
    Risk: "Risiko",
    "Açıklama bulunmuyor.": "Keine Beschreibung vorhanden.",
    "Genel sistem": "Gesamtsystem",
    "Hesabı Engelle": "Konto sperren",
    "Risk kaydı bulunamadı": "Kein Risikoeintrag gefunden",
    "Seçilen durumda incelenecek risk kaydı yok.":
      "Für den gewählten Status gibt es keine Risikoeinträge.",
    "MesPuan kazanma kurallarını ve güvenlik sınırlarını yönetin.":
      "MesPuan-Verdienstregeln und Sicherheitsgrenzen verwalten.",
    "Ayarlar yükleniyor": "Einstellungen werden geladen",
    "MesPuan sistem ayarları hazırlanıyor.":
      "MesPuan-Systemeinstellungen werden vorbereitet.",
    "Kurumsal Puan Kimliği": "Unternehmens-Punkteidentität",
    "Panelde ve kullanıcı ekranlarında gösterilecek puan adını belirleyin.":
      "Punktenamen für Panel und Benutzeransichten festlegen.",
    "Puan adı": "Punktename",
    "Puan sembolü": "Punktesymbol",
    "Temel Puan Kuralları": "Grundlegende Punkteregeln",
    "Kullanıcıların otomatik kazanacağı puanları belirleyin.":
      "Automatisch verdiente Benutzerpunkte festlegen.",
    "Günlük giriş ödülü": "Täglicher Anmeldebonus",
    "Sınırlar ve Geçerlilik": "Grenzen und Gültigkeit",
    "Günlük kazanç, video ve puan geçerlilik sınırları.":
      "Tagesverdienst-, Video- und Punktegültigkeitsgrenzen.",
    "Günlük kazanma sınırı": "Tägliches Verdienstlimit",
    "Puan geçerlilik süresi": "Punktegültigkeit",
    "Günlük azami video": "Maximale Videos pro Tag",
    "Risk dondurma puanı": "Risiko-Sperrschwelle",
    "Seri toleransı": "Serien-Toleranz",
    "Hareket saklama süresi": "Aufbewahrungsdauer",
    gün: "Tage",
    video: "Videos",
    "Sistem ve Güvenlik": "System und Sicherheit",
    "Ana sistem durumunu ve doğrulama kurallarını yönetin.":
      "Systemstatus und Verifizierungsregeln verwalten.",
    "MesPuan sistemi aktif": "MesPuan-System aktiv",
    "Kapalı olduğunda yeni puan kazanılamaz.":
      "Bei Deaktivierung können keine neuen Punkte verdient werden.",
    "Sponsor videoları aktif": "Sponsorvideos aktiv",
    "Kurum içi sponsor kampanyalarını açar.":
      "Aktiviert interne Sponsor-Kampagnen.",
    "AdMob kampanyaları aktif": "AdMob-Kampagnen aktiv",
    "Yalnızca sunucu tarafı SSV doğrulaması kuruluysa açın.":
      "Nur mit eingerichteter serverseitiger SSV-Verifizierung aktivieren.",
    "Günlük seri aktif": "Tägliche Serie aktiv",
    "Ardışık giriş günlerini takip eder.":
      "Verfolgt aufeinanderfolgende Anmeldetage.",
    "Telefon doğrulaması gerekli": "Telefonbestätigung erforderlich",
    "Uygun görevlerde doğrulanmış telefon ister.":
      "Erfordert bei passenden Aufgaben ein bestätigtes Telefon.",
    "Aynı cihazda çoklu hesap koruması":
      "Mehrfachkonto-Schutz pro Gerät",
    "Şüpheli çoklu hesap kullanımını işaretler.":
      "Markiert verdächtige Mehrfachkontonutzung.",
    "Açık rıza zorunlu": "Ausdrückliche Zustimmung erforderlich",
    "Ödüllü içerik öncesinde kullanıcı onayı ister.":
      "Verlangt Zustimmung vor belohnten Inhalten.",
    "Değiştirilemeyen güvenlik kuralları":
      "Unveränderliche Sicherheitsregeln",
    "Kullanıcılar arası transfer, nakde çevirme ve cari hesaba aktarma her zaman kapalıdır.":
      "Übertragungen, Barauszahlung und Kontokorrentbuchung bleiben deaktiviert.",
    "Kaydediliyor...": "Wird gespeichert...",
    "Ayarları Kaydet": "Einstellungen speichern",
    "Görevi Düzenle": "Aufgabe bearbeiten",
    "Yeni MesPuan Görevi": "Neue MesPuan-Aufgabe",
    "Mobil uygulamada gösterilecek görevin kurallarını belirleyin.":
      "Regeln für die in der mobilen App angezeigte Aufgabe festlegen.",
    "Görev başlığı": "Aufgabentitel",
    "Görev açıklaması": "Aufgabenbeschreibung",
    "Görev türü": "Aufgabentyp",
    "Kazandırılacak MesPuan": "MesPuan-Bonus",
    "Günlük katılım sınırı": "Tägliches Teilnahmelimit",
    "Toplam katılım sınırı": "Gesamtes Teilnahmelimit",
    "Toplam puan bütçesi": "Gesamtes Punktebudget",
    "Boş = sınırsız": "Leer = unbegrenzt",
    "Doğrulama yöntemi": "Verifizierungsmethode",

       "Sunucu tarafından": "Serverseitig",
    "Sayfa oturumuyla": "Seitensitzung",
    "Kampanya koduyla": "Mit Kampagnencode",
    "Kullanıcı tamamlamasıyla": "Durch Benutzerabschluss",
    "Sayfada kalma süresi (saniye)":
      "Erforderliche Seitenzeit (Sekunden)",
    "Hedef kitle": "Zielgruppe",


    "Hedef değer": "Zielwert",
    "Kurum, ülke, şehir veya grup değeri":
      "Institutions-, Länder-, Stadt- oder Gruppenwert",
    "Başlangıç tarihi": "Startdatum",
    "Bitiş tarihi": "Enddatum",
    "Hedef bağlantı": "Ziel-URL",
    "Yeni kampanya kodu (isteğe bağlı)":
      "Neuer Kampagnencode (optional)",
    "Kampanya kodu": "Kampagnencode",
    "Kullanıcıya sorulacak metin": "Frage an den Benutzer",
    "Instagram paylaşımındaki kodu yazın":
      "Code aus dem Instagram-Beitrag eingeben",
    "Başarı mesajı": "Erfolgsmeldung",
    "Görev tamamlandı. MesPuan hesabınıza eklendi.":
      "Aufgabe abgeschlossen. MesPuan wurde Ihrem Konto gutgeschrieben.",
    "Yalnızca bir kez tamamlanabilir": "Nur einmal abschließbar",
    "Görev aktif": "Aufgabe aktiv",
    "Görevi Güncelle": "Aufgabe aktualisieren",
    "Görevi Oluştur": "Aufgabe erstellen",
    "Sponsor Videosunu Düzenle": "Sponsorvideo bearbeiten",
    "Yeni Sponsor Videosu": "Neues Sponsorvideo",
    "Video süresini, ödülünü ve kampanya bütçesini tanımlayın.":
      "Videodauer, Bonus und Kampagnenbudget festlegen.",
    "Kampanya başlığı": "Kampagnentitel",
    "Sponsor/firma adı": "Sponsor/Firmenname",
    Sağlayıcı: "Anbieter",
    "MesYat sponsor videosu": "MesYat Sponsorvideo",
    "AdMob (SSV gerekli)": "AdMob (SSV erforderlich)",
    "Video bağlantısı": "Video-URL",
    "Kapak resmi bağlantısı": "Vorschaubild-URL",
    "Video süresi (saniye)": "Videodauer (Sekunden)",
    "Tamamlama oranı (%)": "Abschlussquote (%)",
    "Video ödülü": "Videobonus",
    "Günlük izleme hakkı": "Tägliches Ansichtslimit",
    "Toplam izlenme sınırı": "Gesamtes Ansichtslimit",
    "Sponsor kampanyası aktif": "Sponsor-Kampagne aktiv",
    "Kampanyayı Güncelle": "Kampagne aktualisieren",
    "Kampanyayı Oluştur": "Kampagne erstellen",
    "Cüzdan Düzeltmesi": "Wallet-Korrektur",
    "Cüzdanı Dondur": "Wallet einfrieren",
    "Cüzdanı Aktifleştir": "Wallet reaktivieren",
    "Puan miktarı": "Punktzahl",
    Referans: "Referenz",
    "İsteğe bağlı işlem referansı": "Optionale Vorgangsreferenz",
    "İşlem gerekçesi": "Vorgangsbegründung",
    "Denetim kaydı için ayrıntılı gerekçe yazın":
      "Detaillierte Begründung für den Prüfpfad eingeben",
    Vazgeç: "Abbrechen",
    "İşleniyor...": "Wird verarbeitet...",
    "İşlemi Onayla": "Vorgang bestätigen",
    Kazanılan: "Verdient",
    Önceki: "Zurück",
    Sonraki: "Weiter",
    ARA: "SUCHE",
    "Başlık, kullanıcı veya işlem ara...":
      "Titel, Benutzer oder Vorgang suchen...",
    Filtrele: "Filtern",
    Kapat: "Schließen",
    kayıt: "Einträge",
    Sayfa: "Seite",
  },
};

const I18nContext = createContext({
  language: "tr",
  setLanguage: () => {},
  t: (value) => value,
});

function useI18n() {
  return useContext(I18nContext);
}

function makeTranslator(language) {
  return (value) => {
    if (value === null || value === undefined) return "";
    return TRANSLATIONS[language]?.[value] || value;
  };
}

const SUPER_ADMIN_ROLES = new Set([
  "admin",
  "superadmin",
  "super_admin",
  "root",
]);

const SUPER_ADMIN_EMAILS = new Set([
  "tayfununac@admin.com",
  "yildizmesut.ch@gmail.com",
]);

const TASK_TYPES = [
  { value: "daily_login", label: "Günlük giriş görevi" },
  { value: "instagram_code", label: "Instagram kampanya kodu" },
  { value: "website_code", label: "Web sitesi kampanya kodu" },
  { value: "survey", label: "Anket katılımı" },
  { value: "content_read", label: "İçerik okuma" },
  { value: "qr_visit", label: "QR ziyaret" },
  { value: "profile_complete", label: "Profil tamamlama" },
  { value: "phone_verify", label: "Telefon doğrulama" },
  { value: "purchase", label: "Alışveriş" },
  { value: "referral", label: "Üye daveti" },
];

const TARGET_TYPES = [
  { value: "all", label: "Herkes" },
  { value: "institution", label: "Belirli kurum" },
  { value: "country", label: "Belirli ülke" },
  { value: "city", label: "Belirli şehir" },
  { value: "district", label: "Belirli ilçe" },
  { value: "group", label: "Belirli grup" },
  { value: "new_users", label: "Yeni kullanıcılar" },
];

const MOVEMENT_TYPES = [
  { value: "", label: "Tüm hareketler" },
  { value: "welcome", label: "İlk kayıt ödülü" },
  { value: "daily_login", label: "Günlük giriş" },
  { value: "task_reward", label: "Görev ödülü" },
  { value: "video_reward", label: "Video ödülü" },
  { value: "referral_reward", label: "Arkadaşını getir ödülü" },
  { value: "admin_adjustment", label: "Yönetici düzeltmesi" },
  { value: "marketplace_discount", label: "MesPuan kullanımı" },
];

const NAV_ITEMS = [
  { id: "overview", label: "Genel Bakış", mark: "ÖZ" },
  { id: "tasks", label: "Görevler", mark: "GÖ" },
  { id: "campaigns", label: "Sponsor Videoları", mark: "SV" },
  { id: "discounts", label: "Marketplace İndirimleri", mark: "İD" },
  { id: "wallets", label: "Cüzdanlar", mark: "CÜ" },
  { id: "movements", label: "Hareketler", mark: "HR" },
  { id: "risks", label: "Risk Merkezi", mark: "RS" },
  { id: "settings", label: "Sistem Ayarları", mark: "AY" },
];

const EMPTY_TASK = {
  title: "",
  description: "",
  type: "instagram_code",
  reward_points: 25,
  daily_limit: 1,
  total_completion_limit: "",
  total_budget_points: "",
  start_at: "",
  end_at: "",
  target_type: "all",
  target_value: "",

  verification_method: "code",
  destination_url: "",
  content_min_seconds: 20,
  campaign_code: "",

  question: "",
  success_message: "Görev tamamlandı. MesPuan hesabınıza eklendi.",

first_time_only: false,
requires_phone_verification: false,
active: true,


};




const EMPTY_CAMPAIGN = {
  title: "",
  sponsor_name: "",
  provider: "internal",
  video_url: "",
  thumbnail_url: "",

  duration_seconds: 30,
  completion_percent: 100,
  reward_points: 25,

  daily_view_limit: 1,
  total_view_limit: "",
  budget_points: "",

  start_at: "",
  end_at: "",

  target_type: "all",
  target_value: "",

  ad_category: "general",
  target_min_age: "",
  target_max_age: "",
  target_genders: "all",
  target_sectors: "",
  target_languages: "",

  view_credit_cost: 1,
  click_credit_cost: 0,
  showcase_bid_credits: 0,

  active: true,
};

const EMPTY_DISCOUNT = {
  title: "",
  product_id: "",
  product_name: "",
  required_points: 100,
  discount_type: "fixed",
  discount_value: 10,
  currency: "TRY",
  max_discount_percent: 25,
  campaign_stock: "",
  per_user_limit: 1,
  start_at: "",
  end_at: "",
  active: true,
};

function normalizeToken(rawValue) {
  let value = String(rawValue || "").trim();
  if (!value || value.toLowerCase() === "null") return "";

  if (value.startsWith('"') && value.endsWith('"')) {
    try {
      const decoded = JSON.parse(value);
      if (typeof decoded === "string") value = decoded.trim();
    } catch (_) {
      // Ham değer kullanılmaya devam edilir.
    }
  }

  value = value
    .replace(/^(Bearer\s+)+/i, "")
    .replace(/\s+/g, "")
    .trim();

  return value.split(".").length === 3 ? value : "";
}

function getStoredToken() {
  const keys = [
    "token",
    "auth_token",
    "authToken",
    "jwt_token",
    "access_token",
    "accessToken",
  ];

  for (const storage of [localStorage, sessionStorage]) {
    for (const key of keys) {
      const token = normalizeToken(storage.getItem(key));
      if (token) return token;
    }
  }
  return "";
}

function decodeJwt(token) {
  try {
    const part = token.split(".")[1];
    const normalized = part.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      window
        .atob(normalized)
        .split("")
        .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );
    return JSON.parse(json);
  } catch (_) {
    return {};
  }
}

function getInstitutionId(payload) {
  const value =
    payload.kurum_id ||
    payload.institution_id ||
    payload.kurumId ||
    payload.institutionId;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function toLocalInput(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

function toApiDate(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}



function nullableNumber(value) {
  if (
    value === "" ||
    value === null ||
    value === undefined
  ) {
    return null;
  }

  const number = Number(value);

  return Number.isFinite(number) && number > 0
    ? number
    : null;
}

function normalizeListInput(value) {
  if (Array.isArray(value)) {
    return [
      ...new Set(
        value
          .map((item) => String(item || "").trim())
          .filter(Boolean)
      ),
    ];
  }

  return [
    ...new Set(
      String(value || "")
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
    ),
  ];
}

function formatNumber(value) {

  return new Intl.NumberFormat("tr-TR").format(Number(value || 0));
}

function formatDate(value, withTime = true, language = "tr") {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const locale = { tr: "tr-TR", en: "en-US", de: "de-DE" }[language] || "tr-TR";
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
}

function taskTypeLabel(value) {
  return TASK_TYPES.find((item) => item.value === value)?.label || value || "—";
}

function statusLabel(status) {
  const labels = {
    active: "Aktif",
    inactive: "Pasif",
    scheduled: "Planlandı",
    expired: "Süresi doldu",
    sold_out: "Stokta yok",
    frozen: "Donduruldu",
    blocked: "Engellendi",

    pending: "İncelemede",
    resolved: "Çözüldü",

    approval_pending:
      "Onay Bekliyor",

    approval_rejected:
      "Reddedildi",
  };


  return labels[status] || status || "—";
}

function cx(...values) {
  return values.filter(Boolean).join(" ");
}

function normalizeLanguage(value) {
  const short = String(value || "").toLowerCase().slice(0, 2);
  return ["tr", "en", "de"].includes(short) ? short : "tr";
}

export default function MesyatFrontend({
  authToken = "",
  institutionId = null,
  apiBase = DEFAULT_API_BASE,
  initialLanguage,
}) {
  const [language, setLanguage] = useState(() =>
    normalizeLanguage(
      initialLanguage ||
        localStorage.getItem("mesyat_panel_language") ||
        navigator.language
    )
  );
  const t = useMemo(() => makeTranslator(language), [language]);
  const token = useMemo(
    () => normalizeToken(authToken) || getStoredToken(),
    [authToken]
  );
  const payload = useMemo(() => decodeJwt(token), [token]);
  const role = String(payload.role || payload.rol || "").toLowerCase();
  const email = String(
    payload.email ||
      payload.mail ||
      payload.user_email ||
      payload.eposta ||
      ""
  )
    .trim()
    .toLowerCase();


const isSuperAdmin =
  SUPER_ADMIN_ROLES.has(role) || SUPER_ADMIN_EMAILS.has(email);

// Cüzdanlar bölümü yalnızca bu özel merkez hesabında görünür.
const canManageWallets = email === "mesyat@admin.com";

const ownInstitutionId = getInstitutionId(payload);


  const reklamApiRoot = useMemo(
    () => String(apiBase || DEFAULT_API_BASE).replace(/\/mespuan\/?$/, ""),
    [apiBase]
  );

  const [activeTab, setActiveTab] = useState("overview");
  const [scopeId, setScopeId] = useState(
    institutionId || (isSuperAdmin ? "" : ownInstitutionId || "")
  );
  const [loading, setLoading] = useState(false);
  const [pageError, setPageError] = useState("");
  const [toast, setToast] = useState(null);

  const [dashboard, setDashboard] = useState({
    scope: {
      is_global: false,
      institution_id: null,
    },
    stats: {},
    daily_activity: [],
    top_tasks: [],
  });


  const [tasks, setTasks] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [wallets, setWallets] = useState([]);
  const [movements, setMovements] = useState([]);
  const [risks, setRisks] = useState([]);
  const [settings, setSettings] = useState(null);
  const [meta, setMeta] = useState({});

  const [filters, setFilters] = useState({
    tasks: { q: "", status: "", type: "", page: 1 },
    campaigns: { q: "", status: "", page: 1 },
    discounts: { q: "", status: "", page: 1 },
    wallets: { q: "", status: "", page: 1 },
    movements: {
      q: "",
      type: "",
      date_from: "",
      date_to: "",
      page: 1,
    },
    risks: { q: "", status: "pending", page: 1 },
  });

    const [editor, setEditor] = useState(null);

  const [
    taskEditorError,
    setTaskEditorError,
  ] = useState("");

  const [taskForm, setTaskForm] = useState(EMPTY_TASK);
  const [campaignForm, setCampaignForm] = useState(EMPTY_CAMPAIGN);


  const [discountForm, setDiscountForm] = useState(EMPTY_DISCOUNT);
  const [actionDialog, setActionDialog] = useState(null);

  useEffect(() => {
    localStorage.setItem("mesyat_panel_language", language);
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(null), 4200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const notify = useCallback((message, type = "success") => {
    setToast({ message, type });
  }, []);

  const api = useCallback(
    async (path, options = {}) => {
      if (!token) {
        throw new Error(
          t("Oturum bilgisi bulunamadı. Yeniden giriş yapın.")
        );
      }

      const response = await fetch(`${apiBase}${path}`, {
        method: options.method || "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${token}`,
          ...(options.headers || {}),
        },
        body:
          options.body === undefined
            ? undefined
            : JSON.stringify(options.body),
      });

      if (response.status === 204) return { success: true, data: null };

      let result = {};
      try {
        result = await response.json();
      } catch (_) {
        throw new Error(t("Sunucudan geçerli bir yanıt alınamadı."));
      }

      if (!response.ok || result.success === false) {
        const error = new Error(
          result.message || t("MesPuan işlemi tamamlanamadı.")
        );
        error.code = result.code;
        error.status = response.status;
        throw error;
      }
      return result;
    },
    [apiBase, t, token]
  );

  const scopeQuery = useCallback(
    (extra = {}) => {
      const params = new URLSearchParams();
      if (scopeId) params.set("institution_id", String(scopeId));
      Object.entries(extra).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          params.set(key, String(value));
        }
      });
      const query = params.toString();
      return query ? `?${query}` : "";
    },
    [scopeId]
  );

  const withScopeBody = useCallback(
    (body = {}) => ({
      ...body,
      ...(scopeId ? { institution_id: Number(scopeId) } : {}),
    }),
    [scopeId]
  );

  const loadTab = useCallback(
    async (tab = activeTab, override = {}) => {
      if (!token) {
        setPageError(
          t("Oturum bilgisi bulunamadı. Yeniden giriş yapın.")
        );
        return;
      }

      setLoading(true);
      setPageError("");
      try {
        if (tab === "overview") {
          const result = await api(
            `/admin/dashboard${scopeQuery()}`
          );
          setDashboard(result.data || {});
        }

        if (tab === "tasks") {
          const query = { ...filters.tasks, ...override, limit: 30 };
          const result = await api(
            `/admin/tasks${scopeQuery(query)}`
          );
          setTasks(result.data?.items || []);
          setMeta((current) => ({ ...current, tasks: result.meta || {} }));
        }

        if (tab === "campaigns" && isSuperAdmin) {
          const query = { ...filters.campaigns, ...override, limit: 30 };
          const result = await api(
            `/admin/campaigns${scopeQuery(query)}`
          );
          setCampaigns(result.data?.items || []);
          setMeta((current) => ({
            ...current,
            campaigns: result.meta || {},
          }));
        }

        if (tab === "discounts") {
          const query = { ...filters.discounts, ...override, limit: 30 };
          const result = await api(
            `/admin/discounts${scopeQuery(query)}`
          );
          setDiscounts(result.data?.items || []);
          setMeta((current) => ({
            ...current,
            discounts: result.meta || {},
          }));
        }

     if (tab === "wallets" && canManageWallets) {
  const query = {
    ...filters.wallets,
    ...override,
    limit: 30,
  };

  // Cüzdanlar merkez hesabında kurumdan bağımsız yüklenir.
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      params.set(key, String(value));
    }
  });

  const queryString = params.toString();

  const result = await api(
    `/admin/wallets${queryString ? `?${queryString}` : ""}`
  );

  setWallets(result.data?.items || []);
  setMeta((current) => ({
    ...current,
    wallets: result.meta || {},
  }));
}

        if (tab === "movements") {
          const query = { ...filters.movements, ...override, limit: 40 };
          const result = await api(
            `/admin/movements${scopeQuery(query)}`
          );
          setMovements(result.data?.items || []);
          setMeta((current) => ({
            ...current,
            movements: result.meta || {},
          }));
        }

        if (tab === "risks") {
          const query = { ...filters.risks, ...override, limit: 30 };
          const result = await api(
            `/admin/risk-events${scopeQuery(query)}`
          );
          setRisks(result.data?.items || []);
          setMeta((current) => ({ ...current, risks: result.meta || {} }));
        }

        if (tab === "settings") {
          const result = await api(
            `/admin/settings${scopeQuery()}`
          );
          setSettings(result.data || {});
        }
      } catch (error) {
        setPageError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [activeTab, api, filters, isSuperAdmin, scopeQuery, t, token]
  );

  const handleReklamMessage = useCallback(
    (message) => {
      notify(message?.text || "", message?.type || "success");
      if (message?.type === "success") {
        loadTab("campaigns");
      }
    },
    [loadTab, notify]
  );

  useEffect(() => {
    loadTab(activeTab);
  }, [activeTab, scopeId]); // eslint-disable-line react-hooks/exhaustive-deps

  function changeFilter(section, key, value) {
    setFilters((current) => ({
      ...current,
      [section]: {
        ...current[section],
        [key]: value,
        ...(key !== "page" ? { page: 1 } : {}),
      },
    }));
  }

  function changePage(section, page) {
    changeFilter(section, "page", page);
    loadTab(section, { page });
  }

  function openTaskEditor(task = null) {
    setTaskEditorError("");

    setTaskForm(

      task
        ? {
            ...EMPTY_TASK,
            ...task,
            start_at: toLocalInput(task.start_at),
            end_at: toLocalInput(task.end_at),
            campaign_code: "",
          }
        : {
            ...EMPTY_TASK,
            success_message: t(EMPTY_TASK.success_message),
          }
    );
    setEditor({ type: "task", id: task?.id || null });
  }


  function openCampaignEditor(campaign = null) {
    setCampaignForm(
      campaign
        ? {
            ...EMPTY_CAMPAIGN,
            ...campaign,

            start_at: toLocalInput(
              campaign.start_at
            ),

            end_at: toLocalInput(
              campaign.end_at
            ),

            target_genders: Array.isArray(
              campaign.target_genders
            )
              ? campaign.target_genders.join(", ")
              : campaign.target_genders || "all",

            target_sectors: Array.isArray(
              campaign.target_sectors
            )
              ? campaign.target_sectors.join(", ")
              : campaign.target_sectors || "",

            target_languages: Array.isArray(
              campaign.target_languages
            )
              ? campaign.target_languages.join(", ")
              : campaign.target_languages || "",
          }
        : {
            ...EMPTY_CAMPAIGN,
          }
    );

    setEditor({
      type: "campaign",
      id: campaign?.id || null,
    });
  }


  function openDiscountEditor(discount = null) {
    setDiscountForm(
      discount
        ? {
            ...EMPTY_DISCOUNT,
            ...discount,
            start_at: toLocalInput(discount.start_at),
            end_at: toLocalInput(discount.end_at),
          }
        : { ...EMPTY_DISCOUNT }
    );
    setEditor({ type: "discount", id: discount?.id || null });
  }

  async function saveTask(event) {
    event.preventDefault();

    setTaskEditorError("");
    setLoading(true);

    try {


      const body = withScopeBody({
        ...taskForm,
        reward_points: Number(taskForm.reward_points),
        daily_limit: Number(taskForm.daily_limit),
        total_completion_limit: nullableNumber(
          taskForm.total_completion_limit
        ),
        total_budget_points: nullableNumber(taskForm.total_budget_points),
        start_at: toApiDate(taskForm.start_at),
        end_at: toApiDate(taskForm.end_at),
        target_value:
          taskForm.target_type === "all"
            ? null
            : taskForm.target_value || null,


            destination_url:
          taskForm.destination_url ||
          null,

        content_min_seconds:
          Number(
            taskForm
              .content_min_seconds ||
              20
          ),

        question:
          taskForm.question ||
          null,


        campaign_code: taskForm.campaign_code || undefined,
      });

      await api(
        editor.id ? `/admin/tasks/${editor.id}` : "/admin/tasks",
        {
          method: editor.id ? "PATCH" : "POST",
          body,
        }
      );




      const isEditing =
        Boolean(editor.id);

      setEditor(null);

      notify(
        t(
          isSuperAdmin
            ? (
                isEditing
                  ? "Görev güncellendi."
                  : "Yeni görev oluşturuldu."
              )
            : (
                isEditing
                  ? "Görev güncellendi ve yeniden merkez onayına gönderildi."
                  : "Görev merkez onayına gönderildi."
              )
        )
      );

      await loadTab(
        "tasks"
      );



       } catch (error) {
      const message =
        error?.message ||
        t(
          "MesPuan işlemi tamamlanamadı."
        );

      setTaskEditorError(
        message
      );

      notify(
        message,
        "error"
      );
    } finally {
      setLoading(false);
    }
  }


  async function reviewTask(
    task,
    action
  ) {
    const isReject =
      action === "reject";

    let reviewNote = "";

    if (isReject) {
      reviewNote =
        window.prompt(
          t(
            "Görevin ret gerekçesini yazın."
          ),
          ""
        ) || "";

      if (
        reviewNote
          .trim()
          .length < 5
      ) {
        notify(
          t(
            "Ret gerekçesi en az 5 karakter olmalıdır."
          ),
          "error"
        );

        return;
      }
    } else {
      const confirmed =
        window.confirm(
          t(
            "Bu görev mobil uygulamada yayınlanacaktır. Onaylıyor musunuz?"
          )
        );

      if (!confirmed) {
        return;
      }
    }

    setLoading(true);

    try {
      await api(
        `/admin/tasks/${task.id}/review`,
        {
          method: "POST",
          body: {
            action,
            review_note:
              reviewNote.trim() ||
              null,
          },
        }
      );

      notify(
        t(
          isReject
            ? "Görev reddedildi."
            : "Görev onaylandı ve yayına alındı."
        )
      );

      await loadTab(
        "tasks"
      );
    } catch (error) {
      notify(
        error.message,
        "error"
      );
    } finally {
      setLoading(false);
    }
  }













  async function saveCampaign(event) {
    event.preventDefault();
    setLoading(true);

    try {
      const targetMinAge = nullableNumber(
        campaignForm.target_min_age
      );

      const targetMaxAge = nullableNumber(
        campaignForm.target_max_age
      );

      if (
        targetMinAge !== null &&
        targetMaxAge !== null &&
        targetMaxAge < targetMinAge
      ) {
        throw new Error(
          "Maksimum yaş minimum yaştan küçük olamaz."
        );
      }

      const body = withScopeBody({
        ...campaignForm,

        duration_seconds: Number(
          campaignForm.duration_seconds
        ),

        completion_percent: Number(
          campaignForm.completion_percent
        ),

        reward_points: Number(
          campaignForm.reward_points
        ),

        daily_view_limit: Number(
          campaignForm.daily_view_limit
        ),

        total_view_limit: nullableNumber(
          campaignForm.total_view_limit
        ),

        budget_points: nullableNumber(
          campaignForm.budget_points
        ),

        start_at: toApiDate(
          campaignForm.start_at
        ),

        end_at: toApiDate(
          campaignForm.end_at
        ),

        target_value:
          campaignForm.target_type === "all"
            ? null
            : campaignForm.target_value || null,

        thumbnail_url:
          campaignForm.thumbnail_url || null,

        sponsor_name:
          campaignForm.sponsor_name || null,

        ad_category:
          String(
            campaignForm.ad_category || "general"
          )
            .trim()
            .toLocaleLowerCase("tr-TR"),

        target_min_age: targetMinAge,
        target_max_age: targetMaxAge,

        target_genders: normalizeListInput(
          campaignForm.target_genders
        ),

        target_sectors: normalizeListInput(
          campaignForm.target_sectors
        ),

        target_languages: normalizeListInput(
          campaignForm.target_languages
        ).map(
          (languageCode) =>
            languageCode
              .toLowerCase()
              .split(/[-_]/)[0]
        ),

        view_credit_cost: Math.max(
          0,
          Number(
            campaignForm.view_credit_cost || 0
          )
        ),

        click_credit_cost: Math.max(
          0,
          Number(
            campaignForm.click_credit_cost || 0
          )
        ),

        showcase_bid_credits: Math.max(
          0,
          Number(
            campaignForm.showcase_bid_credits || 0
          )
        ),
      });

      await api(
        editor.id
          ? `/admin/campaigns/${editor.id}`
          : "/admin/campaigns",
        {
          method: editor.id
            ? "PATCH"
            : "POST",
          body,
        }
      );

      setEditor(null);

      notify(
        t(
          editor.id
            ? "Sponsor kampanyası güncellendi."
            : "Sponsor kampanyası oluşturuldu."
        )
      );

      await loadTab("campaigns");
    } catch (error) {
      notify(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  async function saveDiscount(event) {
    event.preventDefault();
    setLoading(true);
    try {
      const body = withScopeBody({
        ...discountForm,
        product_id: discountForm.product_id || null,
        product_name: discountForm.product_name || null,
        required_points: Number(discountForm.required_points),
        discount_value: Number(discountForm.discount_value),
        max_discount_percent: Number(
          discountForm.max_discount_percent
        ),
        campaign_stock: nullableNumber(discountForm.campaign_stock),
        per_user_limit: Number(discountForm.per_user_limit),
        currency: String(discountForm.currency || "TRY").toUpperCase(),
        start_at: toApiDate(discountForm.start_at),
        end_at: toApiDate(discountForm.end_at),
      });

      await api(
        editor.id
          ? `/admin/discounts/${editor.id}`
          : "/admin/discounts",
        {
          method: editor.id ? "PATCH" : "POST",
          body,
        }
      );
      setEditor(null);
      notify(
        t(
          editor.id
            ? "İndirim güncellendi."
            : "Yeni indirim oluşturuldu."
        )
      );
      await loadTab("discounts");
    } catch (error) {
      notify(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  async function deleteEntity(type, id) {
    if (
      !window.confirm(
        t("Bu kaydı pasife alıp arşivlemek istiyor musunuz?")
      )
    ) {
      return;
    }

    setLoading(true);
    try {
      await api(
        type === "task"
          ? `/admin/tasks/${id}${scopeQuery()}`
          : type === "campaign"
          ? `/admin/campaigns/${id}${scopeQuery()}`
          : `/admin/discounts/${id}${scopeQuery()}`,
        { method: "DELETE" }
      );
      notify(
        t(
          type === "task"
            ? "Görev arşivlendi."
            : type === "campaign"
            ? "Kampanya arşivlendi."
            : "İndirim arşivlendi."
        )
      );
      await loadTab(
        type === "task"
          ? "tasks"
          : type === "campaign"
          ? "campaigns"
          : "discounts"
      );
    } catch (error) {
      notify(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  async function saveSettings(event) {
    event.preventDefault();
    setLoading(true);
    try {
      const result = await api("/admin/settings", {
        method: "PUT",
        body: withScopeBody(settings),
      });
      setSettings(result.data || settings);
      notify(t("MesPuan sistem ayarları kaydedildi."));
    } catch (error) {
      notify(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  async function executeWalletAction() {
    const dialog = actionDialog;
    if (!dialog) return;

    setLoading(true);
    try {
      if (dialog.action === "adjust") {
        const amount = Number(dialog.amount);
        if (!amount) throw new Error(t("Puan miktarı sıfır olamaz."));
        if (String(dialog.reason || "").trim().length < 10) {
          throw new Error(
            t("En az 10 karakterlik işlem gerekçesi yazın.")
          );
        }

    await api(`/admin/wallets/${dialog.wallet.id}/adjust`, {
  method: "POST",
  headers: {
    "Idempotency-Key": `panel-adjust-${dialog.wallet.id}-${Date.now()}`,
  },
  body: {
    amount,
    reason: dialog.reason.trim(),
    reference: dialog.reference || null,
  },
});

        notify(t("Cüzdan düzeltme hareketi kaydedildi."));
      } else {
        await api(
          `/admin/wallets/${dialog.wallet.id}/${dialog.action}`,
          {
            method: "POST",


          body: {
  reason:
    dialog.reason ||
    (dialog.action === "freeze"
      ? t("Yönetici güvenlik incelemesi")
      : null),
},


          }
        );
        notify(
          t(dialog.action === "freeze"
            ? "Cüzdan donduruldu."
            : "Cüzdan yeniden aktifleştirildi.")
        );
      }

      setActionDialog(null);
      await loadTab("wallets");
    } catch (error) {
      notify(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  async function executeRiskAction(risk, action) {
    const note = window.prompt(
      action === "block"
        ? t("Engelleme gerekçesini yazın:")
        : t("Çözüm notunu yazın:"),
      action === "block"
        ? t("Risk incelemesi sonucunda hesap engellendi.")
        : t("Yönetici tarafından incelendi ve çözüldü.")
    );
    if (note === null) return;

    setLoading(true);
    try {
      await api(`/admin/risk-events/${risk.id}/${action}`, {
        method: "POST",
        body: withScopeBody({ note }),
      });
      notify(
        t(action === "block"
          ? "Riskli hesap engellendi."
          : "Risk kaydı çözüldü.")
      );
      await loadTab("risks");
    } catch (error) {
      notify(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  const stats =
    dashboard.stats || {};

  const isGlobalDashboard =
    dashboard.scope?.is_global ===
    true;

  return (

    <I18nContext.Provider value={{ language, setLanguage, t }}>
    <div className="mp-admin" lang={language}>
      <style>{STYLES}</style>

      {toast && (
        <div className={cx("mp-toast", `is-${toast.type}`)}>
          <span className="mp-toast-dot" />
          <span>{toast.message}</span>
          <button type="button" onClick={() => setToast(null)}>
            ×
          </button>
        </div>
      )}

      <header className="mp-hero">
        <div>
          <div className="mp-kicker">
            {t("MESYAT DİJİTAL YÖNETİM PANELİ")}
          </div>
          <h1>{t("MesYat Para Yönetimi")}</h1>
          <p>
            {t(
              "Görevleri, sponsor videolarını, MesPuan cüzdanlarını ve güvenlik hareketlerini tek merkezden yönetin."
            )}
          </p>
        </div>

        <div className="mp-hero-actions">
          <label className="mp-language">
            <span>{language.toUpperCase()}</span>
            <select
              value={language}
              onChange={(event) => setLanguage(event.target.value)}
              aria-label="Language"
            >
              {LANGUAGE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          {isSuperAdmin && (
            <label className="mp-scope">
              <span>{t("Kurum kapsamı")}</span>
              <input
                type="number"
                min="1"
                value={scopeId}
                onChange={(event) => setScopeId(event.target.value)}
                placeholder={t("Boş = tüm sistem")}
              />
            </label>
          )}
          {!isSuperAdmin && ownInstitutionId && (
            <div className="mp-scope-badge">
              {t("Kurum ID")} <strong>{ownInstitutionId}</strong>
            </div>
          )}
          <button
            type="button"
            className="mp-btn mp-btn-light"
            onClick={() => loadTab(activeTab)}
            disabled={loading}
          >
            {loading ? t("Yükleniyor...") : t("Verileri Yenile")}
          </button>
        </div>
      </header>

      <div className="mp-layout">
        <aside className="mp-sidebar">
          <div className="mp-brand-card">
            <div className="mp-brand-mark">MP</div>
            <div>
              <strong>MesPuan</strong>
              <span>{t("Kapalı devre sadakat sistemi")}</span>
            </div>
          </div>




   <nav>
  {NAV_ITEMS
    .filter(
      (item) =>
        item.id !== "wallets" || canManageWallets
    )
    .map((item) => (
      <button
        key={item.id}
        type="button"
        className={cx(
          "mp-nav-item",
          activeTab === item.id && "is-active"
        )}
        onClick={() => setActiveTab(item.id)}
      >
        <span className="mp-nav-mark">{item.mark}</span>
        <span>{t(item.label)}</span>
      </button>
    ))}
</nav>





          <div className="mp-security-note">
            <strong>{t("Güvenli cüzdan yapısı")}</strong>
            <p>
              {t(
                "MesPuan nakit değildir, transfer edilemez ve cari hesaba yazılmaz. Bütün hareketler denetlenebilir kayıtlardır."
              )}
            </p>
          </div>
        </aside>

        <main className="mp-content">
          {pageError && (
            <div className="mp-alert is-error">
              <div>
                <strong>{t("İşlem tamamlanamadı")}</strong>
                <span>{pageError}</span>
              </div>
              <button type="button" onClick={() => loadTab(activeTab)}>
                {t("Tekrar dene")}
              </button>
            </div>
          )}

          {activeTab === "overview" && (
            <>
              <PageHeader
                title={t("Genel Bakış")}
                description={t(
                  "MesPuan ekosisteminin güncel performansı ve güvenlik özeti."
                )}
              />

              <section className="mp-stat-grid">


                <StatCard
                  label={t(
                    isGlobalDashboard
                      ? "Sistem Genelindeki MesPuan"
                      : "Kurum Ağındaki MesPuan"
                  )}
                  value={formatNumber(
                    stats.points_in_circulation
                  )}
                  suffix="MP"
                  tone="blue"
                />

                <StatCard
                  label={t("Aktif Cüzdan")}
                  value={formatNumber(stats.active_wallets)}
                  tone="cyan"
                />
                <StatCard
                  label={t("Bugünkü Aktif Kullanıcı")}
                  value={formatNumber(stats.active_users_today)}
                  tone="orange"
                />
                <StatCard
                  label={t("Bugün Tamamlanan Görev")}
                  value={formatNumber(stats.tasks_completed_today)}
                  tone="green"
                />
                <StatCard
                  label={t("Bugün Kazanılan")}
                  value={formatNumber(stats.points_earned_today)}
                  suffix="MP"
                  tone="blue"
                />
                <StatCard
                  label={t("Bugün Kullanılan")}
                  value={formatNumber(stats.points_spent_today)}
                  suffix="MP"
                  tone="orange"
                />
                <StatCard
                  label={t("Açık Risk Kaydı")}
                  value={formatNumber(stats.open_risk_events)}
                  tone="red"
                />
                <StatCard
                  label={t("Kısıtlı Cüzdan")}
                  value={formatNumber(stats.frozen_wallets)}
                  tone="red"
                />
              </section>

              <section className="mp-two-column">
                <div className="mp-panel">
                  <PanelTitle
                    title={t("Son 7 Günlük Hareket")}
                    description={t(
                      "Kazanılan ve kullanılan MesPuan karşılaştırması"
                    )}
                  />
                  <ActivityChart items={dashboard.daily_activity || []} />
                </div>

                <div className="mp-panel">
                  <PanelTitle
                    title={t("En Çok Tamamlanan Görevler")}
                    description={t(
                      "Katılım ve dağıtılan puan performansı"
                    )}
                  />
                  <div className="mp-compact-list">
                    {(dashboard.top_tasks || []).length === 0 ? (
                      <EmptyState
                        title={t("Henüz görev verisi yok")}
                        text={t(
                          "İlk görev oluşturulduğunda performansı burada görünür."
                        )}
                      />
                    ) : (
                      dashboard.top_tasks.map((task, index) => (
                        <div className="mp-rank-row" key={task.id}>
                          <span className="mp-rank">{index + 1}</span>
                          <div>
                            <strong>{task.title}</strong>
                            <span>{t(taskTypeLabel(task.type))}</span>
                          </div>
                          <div className="mp-rank-value">
                            <strong>{formatNumber(task.completion_count)}</strong>
                            <span>{t("tamamlama")}</span>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </section>
            </>
          )}

          {activeTab === "tasks" && (
            <>
              <PageHeader
                title={t("Görev Yönetimi")}
                description={t(
                  "Instagram kodu, anket, içerik ve doğrulanmış sistem görevlerini yönetin."
                )}
                action={
                  <button
                    type="button"
                    className="mp-btn mp-btn-primary"
                    onClick={() => openTaskEditor()}
                  >
                    {t("Yeni Görev Oluştur")}
                  </button>
                }
              />

              <FilterBar
                onSubmit={() => loadTab("tasks")}
                searchValue={filters.tasks.q}
                onSearch={(value) => changeFilter("tasks", "q", value)}
              >
                <select
                  value={filters.tasks.type}
                  onChange={(event) =>
                    changeFilter("tasks", "type", event.target.value)
                  }
                >
                  <option value="">{t("Tüm görev türleri")}</option>
                  {TASK_TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {t(type.label)}
                    </option>
                  ))}
                </select>
                <select
                  value={filters.tasks.status}
                  onChange={(event) =>
                    changeFilter("tasks", "status", event.target.value)
                  }
                >



                  <option value="">
                    {t("Tüm durumlar")}
                  </option>

                  <option value="pending">
                    {t("Onay Bekleyenler")}
                  </option>

                  <option value="rejected">
                    {t("Reddedilenler")}
                  </option>

                  <option value="approved">
                    {t("Onaylanmış Görevler")}
                  </option>

                  <option value="active">
                    {t("Aktif")}
                  </option>

                  <option value="inactive">
                    {t("Pasif")}
                  </option>


                </select>
              </FilterBar>

              <div className="mp-panel mp-table-panel">
                <div className="mp-table-scroll">
                  <table>
                    <thead>
                      <tr>
                        <th>{t("Görev")}</th>
                        <th>{t("Tür")}</th>
                        <th>{t("Ödül")}</th>
                        <th>{t("Katılım")}</th>
                        <th>{t("Dağıtılan")}</th>
                        <th>{t("Durum")}</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {tasks.map((task) => (
                        <tr key={task.id}>
                          <td>
                            <div className="mp-main-cell">
                              <strong>{task.title}</strong>



                              <span>
                                {task.description ||
                                  t(
                                    "Açıklama yok"
                                  )}
                              </span>

                              {task.review_note && (
                                <span
                                  style={{
                                    marginTop: 6,
                                    color:
                                      task.status ===
                                      "approval_rejected"
                                        ? "#b42318"
                                        : "#64748b",
                                    fontWeight: 800,
                                  }}
                                >
                                  {t(
                                    "Yönetici notu"
                                  )}
                                  :{" "}
                                  {
                                    task.review_note
                                  }
                                </span>
                              )}

                            </div>
                          </td>
                          <td>{t(taskTypeLabel(task.type))}</td>
                          <td>
                            <strong className="mp-points">
                              +{formatNumber(task.reward_points)} MP
                            </strong>
                          </td>
                          <td>{formatNumber(task.completion_count)}</td>
                          <td>{formatNumber(task.distributed_points)} MP</td>
                          <td>
                            <StatusBadge status={task.status} />
                          </td>



                          <td>
                            <div className="mp-inline-actions">
                              {isSuperAdmin &&
                                task.status ===
                                  "approval_pending" && (
                                  <>
                                    <button
                                      type="button"
                                      disabled={loading}
                                      onClick={() =>
                                        reviewTask(
                                          task,
                                          "approve"
                                        )
                                      }
                                    >
                                      {t("Onayla")}
                                    </button>

                                    <button
                                      type="button"
                                      className="is-danger"
                                      disabled={loading}
                                      onClick={() =>
                                        reviewTask(
                                          task,
                                          "reject"
                                        )
                                      }
                                    >
                                      {t("Reddet")}
                                    </button>
                                  </>
                                )}

                              <button
                                type="button"
                                onClick={() =>
                                  openTaskEditor(
                                    task
                                  )
                                }
                              >
                                {t("Düzenle")}
                              </button>

                              <button
                                type="button"
                                className="is-danger"
                                onClick={() =>
                                  deleteEntity(
                                    "task",
                                    task.id
                                  )
                                }
                              >
                                {t("Arşivle")}
                              </button>
                            </div>
                          </td>



                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {tasks.length === 0 && (
                  <EmptyState
                    title={t("Görev bulunamadı")}
                    text={t(
                      "Filtreyi değiştirin veya yeni bir MesPuan görevi oluşturun."
                    )}
                  />
                )}
                <Pagination
                  meta={meta.tasks}
                  onChange={(page) => changePage("tasks", page)}
                />
              </div>
            </>
          )}

          {activeTab === "campaigns" && !isSuperAdmin && (
            <MespuanReklamBasvuru
              token={token}
              language={language}
              apiBase={apiBase}
            />
          )}

          {activeTab === "campaigns" && isSuperAdmin && (
            <>
              <MespuanReklamBasvurulari
                API={reklamApiRoot}
                token={token}
                setMessage={handleReklamMessage}
              />

              <div style={{ height: 24 }} />

              <PageHeader
                title={t("Sponsor Video Yönetimi")}
                description={t(
                  "Sponsor videolarını, izleme haklarını ve puan bütçelerini yönetin."
                )}
                action={
                  <button
                    type="button"
                    className="mp-btn mp-btn-primary"
                    onClick={() => openCampaignEditor()}
                  >
                    {t("Sponsor Videosu Ekle")}
                  </button>
                }
              />

              <FilterBar
                onSubmit={() => loadTab("campaigns")}
                searchValue={filters.campaigns.q}
                onSearch={(value) =>
                  changeFilter("campaigns", "q", value)
                }
              >
                <select
                  value={filters.campaigns.status}
                  onChange={(event) =>
                    changeFilter("campaigns", "status", event.target.value)
                  }
                >
                  <option value="">{t("Tüm durumlar")}</option>
                  <option value="active">{t("Aktif")}</option>
                  <option value="inactive">{t("Pasif")}</option>
                </select>
              </FilterBar>

              {campaigns.length === 0 ? (
                <div className="mp-panel">
                  <EmptyState
                    title={t("Sponsor kampanyası bulunamadı")}
                    text={t(
                      "İlk sponsor videosunu ekleyerek MesPuan kampanyasını başlatın."
                    )}
                  />
                </div>
              ) : (
                <div className="mp-campaign-grid">
                  {campaigns.map((campaign) => {
                    const budget = Number(campaign.budget_points || 0);
                    const spent = Number(campaign.spent_points || 0);
                    const percent = budget
                      ? Math.min(100, Math.round((spent / budget) * 100))
                      : 0;

                    return (
                      <article className="mp-campaign-card" key={campaign.id}>
                        <div className="mp-video-cover">
                          {campaign.thumbnail_url ? (
                            <img
                              src={campaign.thumbnail_url}
                              alt={campaign.title}
                            />
                          ) : (
                            <div className="mp-video-placeholder">MP</div>
                          )}
                          <span className="mp-reward-chip">
                            +{formatNumber(campaign.reward_points)} MP
                          </span>
                          <span className="mp-duration-chip">
                            {campaign.duration_seconds} sn
                          </span>
                        </div>
                        <div className="mp-campaign-body">
                          <div className="mp-card-title-row">
                            <div>
                              <strong>{campaign.title}</strong>
                              <span>
                                {campaign.sponsor_name ||
                                  t("MesYat sponsor kampanyası")}
                              </span>
                            </div>
                            <StatusBadge status={campaign.status} />
                          </div>




                                            <div className="mp-mini-stats">
                            <div>
                              <span>{t("Tamamlanan")}</span>
                              <strong>
                                {formatNumber(
                                  campaign.completed_views
                                )}
                              </strong>
                            </div>

                            <div>
                              <span>{t("Günlük hak")}</span>
                              <strong>
                                {campaign.daily_view_limit}
                              </strong>
                            </div>

                            <div>
                              <span>{t("İzleme oranı")}</span>
                              <strong>
                                %{campaign.completion_percent}
                              </strong>
                            </div>

                            <div>
                              <span>
                                {t("İzleme kredi bedeli")}
                              </span>
                              <strong>
                                {formatNumber(
                                  campaign.view_credit_cost
                                )}{" "}
                                MRK
                              </strong>
                            </div>

                            <div>
                              <span>
                                {t("Tıklama kredi bedeli")}
                              </span>
                              <strong>
                                {formatNumber(
                                  campaign.click_credit_cost
                                )}{" "}
                                MRK
                              </strong>
                            </div>

                            <div>
                              <span>
                                {t("Vitrin teklif kredisi")}
                              </span>
                              <strong>
                                {formatNumber(
                                  campaign.showcase_bid_credits
                                )}{" "}
                                MRK
                              </strong>
                            </div>
                          </div>

                          {campaign.credit_paused && (
                            <div className="mp-locked-rules">
                              <strong>
                                {t(
                                  "Reklam kredisi nedeniyle duraklatıldı"
                                )}
                              </strong>
                              <span>
                                {t(
                                  "Kampanyanın tekrar yayınlanması için kurum reklam kredisi yüklenmelidir."
                                )}
                              </span>
                            </div>
                          )}



                          <div className="mp-budget">
                            <div>
                              <span>{t("Puan bütçesi")}</span>
                              <strong>
                                {formatNumber(spent)} /{" "}
                                {budget
                                  ? formatNumber(budget)
                                  : t("Sınırsız")} MP
                              </strong>
                            </div>
                            <div className="mp-progress">
                              <i style={{ width: `${percent}%` }} />
                            </div>
                          </div>

                          <div className="mp-card-actions">
                            <button
                              type="button"
                              onClick={() => openCampaignEditor(campaign)}
                            >
                              {t("Düzenle")}
                            </button>
                            <button
                              type="button"
                              className="is-danger"
                              onClick={() =>
                                deleteEntity("campaign", campaign.id)
                              }
                            >
                              {t("Arşivle")}
                            </button>
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>
              )}
              <Pagination
                meta={meta.campaigns}
                onChange={(page) => changePage("campaigns", page)}
              />
            </>
          )}

          {activeTab === "discounts" && (
            <>
              <PageHeader
                title={t("İndirim Yönetimi")}
                description={t(
                  "MesPuan karşılığında kullanılabilecek ürün ve hizmet indirimlerini yönetin."
                )}
                action={
                  <button
                    type="button"
                    className="mp-btn mp-btn-primary"
                    onClick={() => openDiscountEditor()}
                  >
                    {t("Yeni İndirim Oluştur")}
                  </button>
                }
              />

              <FilterBar
                onSubmit={() => loadTab("discounts")}
                searchValue={filters.discounts.q}
                onSearch={(value) =>
                  changeFilter("discounts", "q", value)
                }
              >
                <select
                  value={filters.discounts.status}
                  onChange={(event) =>
                    changeFilter(
                      "discounts",
                      "status",
                      event.target.value
                    )
                  }
                >
                  <option value="">{t("Tüm durumlar")}</option>
                  <option value="active">{t("Aktif")}</option>
                  <option value="inactive">{t("Pasif")}</option>
                </select>
              </FilterBar>

              {discounts.length === 0 ? (
                <div className="mp-panel">
                  <EmptyState
                    title={t("İndirim bulunamadı")}
                    text={t(
                      "İlk Marketplace indirimini oluşturarak MesPuan kullanımını başlatın."
                    )}
                  />
                </div>
              ) : (
                <div className="mp-discount-grid">
                  {discounts.map((discount) => {
                    const stock = Number(discount.campaign_stock || 0);
                    const used = Number(discount.redeemed_count || 0);
                    const remaining = stock
                      ? Math.max(0, stock - used)
                      : null;
                    const discountValue =
                      discount.discount_type === "percentage"
                        ? `%${formatNumber(discount.discount_value)}`
                        : `${formatNumber(discount.discount_value)} ${
                            discount.currency || "TRY"
                          }`;

                    return (
                      <article
                        className="mp-discount-card"
                        key={discount.id}
                      >
                        <div className="mp-discount-top">
                          <div className="mp-discount-mark">MP</div>
                          <StatusBadge status={discount.status} />
                        </div>
                        <div className="mp-discount-content">
                          <span className="mp-discount-product">
                            {discount.product_name ||
                              discount.product_id ||
                              "Marketplace"}
                          </span>
                          <h3>{discount.title}</h3>
                          <div className="mp-discount-value">
                            {discountValue}
                          </div>
                          <div className="mp-mini-stats">
                            <div>
                              <span>{t("Gerekli MesPuan")}</span>
                              <strong>
                                {formatNumber(discount.required_points)} MP
                              </strong>
                            </div>
                            <div>
                              <span>{t("Kullanım")}</span>
                              <strong>{formatNumber(used)}</strong>
                            </div>
                            <div>
                              <span>{t("Stok")}</span>
                              <strong>
                                {remaining === null
                                  ? t("Sınırsız")
                                  : formatNumber(remaining)}
                              </strong>
                            </div>
                          </div>
                          <div className="mp-card-actions">
                            <button
                              type="button"
                              onClick={() =>
                                openDiscountEditor(discount)
                              }
                            >
                              {t("Düzenle")}
                            </button>
                            <button
                              type="button"
                              className="is-danger"
                              onClick={() =>
                                deleteEntity("discount", discount.id)
                              }
                            >
                              {t("Arşivle")}
                            </button>
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>
              )}
              <Pagination
                meta={meta.discounts}
                onChange={(page) => changePage("discounts", page)}
              />
            </>
          )}

        {activeTab === "wallets" && canManageWallets && (
            <>
              <PageHeader
                title={t("Cüzdan Yönetimi")}
                description={t(
                  "Kullanıcı bakiyelerini ve güvenlik durumlarını inceleyin."
                )}
              />
              <FilterBar
                onSubmit={() => loadTab("wallets")}
                searchValue={filters.wallets.q}
                onSearch={(value) => changeFilter("wallets", "q", value)}
              >
                <select
                  value={filters.wallets.status}
                  onChange={(event) =>
                    changeFilter("wallets", "status", event.target.value)
                  }
                >
                  <option value="">{t("Tüm durumlar")}</option>
                  <option value="active">{t("Aktif")}</option>
                  <option value="frozen">{t("Dondurulmuş")}</option>
                  <option value="blocked">{t("Engellenmiş")}</option>
                </select>
              </FilterBar>

              <div className="mp-panel mp-table-panel">
                <div className="mp-table-scroll">
                  <table>
                    <thead>
                      <tr>
                        <th>{t("Kullanıcı")}</th>
                        <th>{t("Bakiye")}</th>
                        <th>{t("Toplam Kazanç")}</th>
                        <th>{t("Kullanılan")}</th>
                        <th>{t("Seri")}</th>
                        <th>{t("Durum")}</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {wallets.map((wallet) => (
                        <tr key={wallet.id}>
                          <td>
                            <div className="mp-user-cell">
                              <span className="mp-avatar">
                                {(wallet.user_name || "K")
                                  .slice(0, 1)
                                  .toUpperCase()}
                              </span>
                              <div>
                                <strong>
                                  {wallet.user_name ||
                                    `${t("Kullanıcı")} #${wallet.user_id}`}
                                </strong>
                                <span>
                                  {wallet.phone ||
                                    wallet.email ||
                                    `ID: ${wallet.user_id}`}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <strong className="mp-balance">
                              {formatNumber(wallet.balance)} MP
                            </strong>
                          </td>
                          <td>{formatNumber(wallet.lifetime_earned)} MP</td>
                          <td>{formatNumber(wallet.lifetime_spent)} MP</td>
                          <td>
                            {wallet.current_streak || 0} {t("gün")}
                          </td>
                          <td>
                            <StatusBadge status={wallet.status} />
                          </td>
                          <td>
                            <div className="mp-inline-actions">
                              <button
                                type="button"
                                onClick={() =>
                                  setActionDialog({
                                    action: "adjust",
                                    wallet,
                                    amount: "",
                                    reason: "",
                                    reference: "",
                                  })
                                }
                              >
                                {t("Düzelt")}
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  setActionDialog({
                                    action:
                                      wallet.status === "frozen"
                                        ? "unfreeze"
                                        : "freeze",
                                    wallet,
                                    reason: "",
                                  })
                                }
                              >
                                {wallet.status === "frozen"
                                  ? t("Aktifleştir")
                                  : t("Dondur")}
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {wallets.length === 0 && (
                  <EmptyState
                    title={t("Cüzdan bulunamadı")}
                    text={t(
                      "Arama ölçütlerinize uygun MesPuan cüzdanı yok."
                    )}
                  />
                )}
                <Pagination
                  meta={meta.wallets}
                  onChange={(page) => changePage("wallets", page)}
                />
              </div>
            </>
          )}

          {activeTab === "movements" && (
            <>
              <PageHeader
                title={t("MesPuan Hareketleri")}
                description={t(
                  "Değiştirilemeyen puan hareketlerini işlem ve kullanıcı bazında inceleyin."
                )}
              />
              <FilterBar
                onSubmit={() => loadTab("movements")}
                searchValue={filters.movements.q}
                onSearch={(value) => changeFilter("movements", "q", value)}
              >
                <select
                  value={filters.movements.type}
                  onChange={(event) =>
                    changeFilter("movements", "type", event.target.value)
                  }
                >
                  {MOVEMENT_TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {t(type.label)}
                    </option>
                  ))}
                </select>
                <input
                  type="date"
                  value={filters.movements.date_from}
                  onChange={(event) =>
                    changeFilter(
                      "movements",
                      "date_from",
                      event.target.value
                    )
                  }
                />
                <input
                  type="date"
                  value={filters.movements.date_to}
                  onChange={(event) =>
                    changeFilter(
                      "movements",
                      "date_to",
                      event.target.value
                    )
                  }
                />
              </FilterBar>

              <div className="mp-panel mp-table-panel">
                <div className="mp-table-scroll">
                  <table>
                    <thead>
                      <tr>
                        <th>{t("İşlem")}</th>
                        <th>{t("Kullanıcı")}</th>
                        <th>{t("Kurum")}</th>
                        <th>{t("Tutar")}</th>
                        <th>{t("Son Bakiye")}</th>
                        <th>{t("Tarih")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {movements.map((movement) => {
                        const positive = Number(movement.amount) > 0;
                        return (
                          <tr key={movement.id}>
                            <td>
                              <div className="mp-main-cell">
                                <strong>{movement.description}</strong>
                                <span>{movement.transaction_no}</span>
                              </div>
                            </td>
                            <td>{movement.user_name || "—"}</td>
                            <td>
                              {movement.institution_name || t("Genel")}
                            </td>
                            <td>
                              <strong
                                className={
                                  positive
                                    ? "mp-amount-positive"
                                    : "mp-amount-negative"
                                }
                              >
                                {positive ? "+" : ""}
                                {formatNumber(movement.amount)} MP
                              </strong>
                            </td>
                            <td>{formatNumber(movement.balance_after)} MP</td>
                            <td>
                              {formatDate(
                                movement.created_at,
                                true,
                                language
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {movements.length === 0 && (
                  <EmptyState
                    title={t("Hareket bulunamadı")}
                    text={t(
                      "Seçilen filtrelerde MesPuan hareketi bulunmuyor."
                    )}
                  />
                )}
                <Pagination
                  meta={meta.movements}
                  onChange={(page) => changePage("movements", page)}
                />
              </div>
            </>
          )}

          {activeTab === "risks" && (
            <>
              <PageHeader
                title={t("Risk Merkezi")}
                description={t(
                  "Şüpheli hareketleri inceleyin, çözün veya riskli cüzdanları engelleyin."
                )}
              />
              <FilterBar
                onSubmit={() => loadTab("risks")}
                searchValue={filters.risks.q}
                onSearch={(value) => changeFilter("risks", "q", value)}
              >
                <select
                  value={filters.risks.status}
                  onChange={(event) =>
                    changeFilter("risks", "status", event.target.value)
                  }
                >
                  <option value="">{t("Tüm durumlar")}</option>
                  <option value="pending">{t("İncelemede")}</option>
                  <option value="resolved">{t("Çözüldü")}</option>
                  <option value="blocked">{t("Engellendi")}</option>
                </select>
              </FilterBar>

              <div className="mp-risk-list">
                {risks.map((risk) => (
                  <article className="mp-risk-card" key={risk.id}>
                    <div
                      className={cx(
                        "mp-risk-score",
                        Number(risk.score) >= 70 && "is-high"
                      )}
                    >
                      <strong>{risk.score}</strong>
                      <span>{t("Risk")}</span>
                    </div>
                    <div className="mp-risk-content">
                      <div className="mp-card-title-row">
                        <div>
                          <strong>{risk.title}</strong>
                          <span>
                            {risk.user_name ||
                              `${t("Kullanıcı")} #${risk.user_id || "—"}`}
                          </span>
                        </div>
                        <StatusBadge status={risk.status} />
                      </div>
                      <p>
                        {risk.description || t("Açıklama bulunmuyor.")}
                      </p>
                      <div className="mp-risk-meta">
                        <span>{risk.type}</span>
                        <span>
                          {risk.institution_name || t("Genel sistem")}
                        </span>
                        <span>
                          {formatDate(risk.created_at, true, language)}
                        </span>
                      </div>
                    </div>
                    {risk.status === "pending" && (
                      <div className="mp-risk-actions">
                        <button
                          type="button"
                          onClick={() => executeRiskAction(risk, "resolve")}
                        >
                          {t("Çözüldü")}
                        </button>
                        <button
                          type="button"
                          className="is-danger"
                          onClick={() => executeRiskAction(risk, "block")}
                        >
                          {t("Hesabı Engelle")}
                        </button>
                      </div>
                    )}
                  </article>
                ))}
                {risks.length === 0 && (
                  <div className="mp-panel">
                    <EmptyState
                      title={t("Risk kaydı bulunamadı")}
                      text={t(
                        "Seçilen durumda incelenecek risk kaydı yok."
                      )}
                    />
                  </div>
                )}
              </div>
              <Pagination
                meta={meta.risks}
                onChange={(page) => changePage("risks", page)}
              />
            </>
          )}

          {activeTab === "settings" && (
            <>
              <PageHeader
                title={t("Sistem Ayarları")}
                description={t(
                  "MesPuan kazanma kurallarını ve güvenlik sınırlarını yönetin."
                )}
              />

              {!settings ? (
                <div className="mp-panel">
                  <EmptyState
                    title={t("Ayarlar yükleniyor")}
                    text={t("MesPuan sistem ayarları hazırlanıyor.")}
                  />
                </div>
              ) : (
                <form className="mp-settings-form" onSubmit={saveSettings}>
                  <SettingsSection
                    title={t("Kurumsal Puan Kimliği")}
                    description={t(
                      "Panelde ve kullanıcı ekranlarında gösterilecek puan adını belirleyin."
                    )}
                  >
                    <TextSetting
                      label={t("Puan adı")}
                      value={settings.point_name}
                      maxLength={50}
                      onChange={(value) =>
                        setSettings({ ...settings, point_name: value })
                      }
                    />
                    <TextSetting
                      label={t("Puan sembolü")}
                      value={settings.point_symbol}
                      maxLength={12}
                      onChange={(value) =>
                        setSettings({ ...settings, point_symbol: value })
                      }
                    />

                  </SettingsSection>

                  <SettingsSection
                    title={t("Temel Puan Kuralları")}
                    description={t(
                      "Kullanıcıların otomatik kazanacağı puanları belirleyin."
                    )}
                  >
                    <NumberSetting
                      label={t("İlk kayıt ödülü")}
                      value={settings.welcome_points}
                      suffix="MP"
                      min={0}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          welcome_points: value,
                        })
                      }
                    />

                    <NumberSetting
                      label={t("Günlük giriş ödülü")}
                      value={settings.daily_login_points}
                      suffix="MP"
                      min={0}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          daily_login_points: value,
                        })
                      }
                    />

                    <NumberSetting
                      label={t("Telefon doğrulama")}
                      value={settings.phone_verify_points}
                      suffix="MP"
                      min={0}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          phone_verify_points: value,
                        })
                      }
                    />

                    <NumberSetting
                      label={t("Profil tamamlama")}
                      value={settings.profile_complete_points}
                      suffix="MP"
                      min={0}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          profile_complete_points: value,
                        })
                      }
                    />

                    <NumberSetting
                      label={t("Arkadaşını getir ödülü")}
                      value={settings.referral_reward_points}
                      suffix="MP"
                      min={0}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          referral_reward_points: value,
                        })
                      }
                    />

                    <NumberSetting
                      label={t("Günlük davet ödülü sınırı")}
                      value={
                        settings.referral_daily_reward_limit
                      }
                      suffix={t("kayıt")}
                      min={1}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          referral_daily_reward_limit: value,
                        })
                      }
                    />

                    <NumberSetting
                      label={t("Davet kodu geçerlilik süresi")}
                      value={settings.referral_claim_days}
                      suffix={t("gün")}
                      min={1}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          referral_claim_days: value,
                        })
                      }
                    />
                  </SettingsSection>

                  <SettingsSection
                    title={t("Sınırlar ve Geçerlilik")}                    description={t(
                      "Günlük kazanç, video ve puan geçerlilik sınırları."
                    )}
                  >
                    <NumberSetting
                      label={t("Günlük kazanma sınırı")}
                      value={settings.daily_earn_limit}
                      suffix="MP"
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          daily_earn_limit: value,
                        })
                      }
                    />
                    <NumberSetting
                      label={t("Puan geçerlilik süresi")}
                      value={settings.point_expiry_days}
                      suffix={t("gün")}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          point_expiry_days: value,
                        })
                      }
                    />
                    <NumberSetting
                      label={t("Günlük azami video")}
                      value={settings.max_video_views_per_day}
                      suffix={t("video")}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          max_video_views_per_day: value,
                        })
                      }
                    />
                    <NumberSetting
                      label={t("Risk dondurma puanı")}
                      value={settings.risk_auto_freeze_score}
                      suffix="/ 100"
                      min={1}
                      max={100}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          risk_auto_freeze_score: value,
                        })
                      }
                    />
                    <NumberSetting
                      label={t("Seri toleransı")}
                      value={settings.streak_grace_days}
                      suffix={t("gün")}
                      min={0}
                      max={3}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          streak_grace_days: value,
                        })
                      }
                    />
                    <NumberSetting
                      label={t("Hareket saklama süresi")}
                      value={settings.movement_retention_days}
                      suffix={t("gün")}
                      min={365}
                      onChange={(value) =>
                        setSettings({
                          ...settings,
                          movement_retention_days: value,
                        })
                      }
                    />
                  </SettingsSection>

                  <SettingsSection
                    title={t("Sistem ve Güvenlik")}
                    description={t(
                      "Ana sistem durumunu ve doğrulama kurallarını yönetin."
                    )}
                  >
                                       <ToggleSetting
                      label={t("MesPuan sistemi aktif")}
                      description={t(
                        "Kapalı olduğunda yeni puan kazanılamaz."
                      )}
                      checked={Boolean(
                        settings.system_active
                      )}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          system_active: checked,
                        })
                      }
                    />

                    <ToggleSetting
                      label={t(
                        "Arkadaşını getir sistemi aktif"
                      )}
                      description={t(
                        "Doğrulanmış yeni kullanıcı davetlerinde davetçiye MesPuan kazandırır."
                      )}
                      checked={Boolean(
                        settings.referral_active
                      )}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          referral_active: checked,
                        })
                      }
                    />

                    <ToggleSetting
                      label={t(
                        "Davet için telefon doğrulaması gerekli"
                      )}
                      description={t(
                        "Davet ödülü verilmeden önce yeni kullanıcının telefonunu doğrulamasını ister."
                      )}
                      checked={Boolean(
                        settings.referral_requires_phone_verification
                      )}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          referral_requires_phone_verification:
                            checked,
                        })
                      }
                    />

                    <ToggleSetting
                      label={t("Sponsor videoları aktif")}
                      description={t(
                        "Kurum içi sponsor kampanyalarını açar."
                      )}
                      checked={Boolean(settings.internal_sponsor_active)}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          internal_sponsor_active: checked,
                        })
                      }
                    />
                    <ToggleSetting
                      label={t("AdMob kampanyaları aktif")}
                      description={t(
                        "Yalnızca sunucu tarafı SSV doğrulaması kuruluysa açın."
                      )}
                      checked={Boolean(settings.admob_active)}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          admob_active: checked,
                        })
                      }
                    />
                    <ToggleSetting
                      label={t("Günlük seri aktif")}
                      description={t(
                        "Ardışık giriş günlerini takip eder."
                      )}
                      checked={Boolean(settings.streak_active)}
                      onChange={(checked) =>
                        setSettings({ ...settings, streak_active: checked })
                      }
                    />
                    <ToggleSetting
                      label={t("Telefon doğrulaması gerekli")}
                      description={t(
                        "Uygun görevlerde doğrulanmış telefon ister."
                      )}
                      checked={Boolean(settings.require_phone_verification)}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          require_phone_verification: checked,
                        })
                      }
                    />
                    <ToggleSetting
                      label={t("Aynı cihazda çoklu hesap koruması")}
                      description={t(
                        "Şüpheli çoklu hesap kullanımını işaretler."
                      )}
                      checked={Boolean(
                        settings.prevent_same_device_accounts
                      )}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          prevent_same_device_accounts: checked,
                        })
                      }
                    />
                    <ToggleSetting
                      label={t("Açık rıza zorunlu")}
                      description={t(
                        "Ödüllü içerik öncesinde kullanıcı onayı ister."
                      )}
                      checked={Boolean(settings.consent_required)}
                      onChange={(checked) =>
                        setSettings({
                          ...settings,
                          consent_required: checked,
                        })
                      }
                    />
                  </SettingsSection>

                  <div className="mp-locked-rules">
                    <strong>
                      {t("Değiştirilemeyen güvenlik kuralları")}
                    </strong>
                    <span>
                      {t(
                        "Kullanıcılar arası transfer, nakde çevirme ve cari hesaba aktarma her zaman kapalıdır."
                      )}
                    </span>
                  </div>

                  <div className="mp-form-footer">
                    <button
                      type="submit"
                      className="mp-btn mp-btn-primary"
                      disabled={loading}
                    >
                      {loading
                        ? t("Kaydediliyor...")
                        : t("Ayarları Kaydet")}
                    </button>
                  </div>
                </form>
              )}
            </>
          )}
        </main>
      </div>

      {editor?.type === "task" && (
        <Modal
          title={t(editor.id ? "Görevi Düzenle" : "Yeni MesPuan Görevi")}
          subtitle={t(
            "Mobil uygulamada gösterilecek görevin kurallarını belirleyin."
          )}
          onClose={() => setEditor(null)}
        >


          <form onSubmit={saveTask}>
            {taskEditorError && (
              <div
                className="mp-alert is-error"
                role="alert"
              >
                <div>
                  <strong>
                    {t(
                      "İşlem tamamlanamadı"
                    )}
                  </strong>

                  <span>
                    {taskEditorError}
                  </span>
                </div>
              </div>
            )}

            <div className="mp-form-grid">

              <Field label={t("Görev başlığı")} wide required>
                <input
                  value={taskForm.title}
                  onChange={(event) =>
                    setTaskForm({ ...taskForm, title: event.target.value })
                  }
                  maxLength={180}
                  required
                />
              </Field>
              <Field label={t("Görev açıklaması")} wide>
                <textarea
                  value={taskForm.description}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      description: event.target.value,
                    })
                  }
                  rows={3}
                  maxLength={3000}
                />
              </Field>
              <Field label={t("Görev türü")} required>
                <select
                  value={taskForm.type}
                  onChange={(event) => {
                    const type = event.target.value;
                    setTaskForm({
                      ...taskForm,
                      type,


                                        verification_method:
                        type ===
                        "content_read"
                          ? "session"
                          : [
                              "instagram_code",
                              "website_code",
                            ].includes(type)
                          ? "code"
                          : [
                              "purchase",
                              "referral",
                              "phone_verify",
                              "profile_complete",
                              "qr_visit",
                            ].includes(type)
                          ? "server"
                          : "user",



                    });
                  }}
                >
                  {TASK_TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {t(type.label)}
                    </option>
                  ))}
                </select>
              </Field>
              <Field label={t("Kazandırılacak MesPuan")} required>
                <input
                  type="number"
                  min="1"
                  value={taskForm.reward_points}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      reward_points: event.target.value,
                    })
                  }
                  required
                />
              </Field>
              <Field label={t("Günlük katılım sınırı")}>
                <input
                  type="number"
                  min="1"
                  value={taskForm.daily_limit}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      daily_limit: event.target.value,
                    })
                  }
                />
              </Field>
              <Field label={t("Toplam katılım sınırı")}>
                <input
                  type="number"
                  min="1"
                  value={taskForm.total_completion_limit}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      total_completion_limit: event.target.value,
                    })
                  }
                  placeholder={t("Boş = sınırsız")}
                />
              </Field>



              <Field label={t("Toplam puan bütçesi")}>
                <input
                  type="number"
                  min="1"
                  value={taskForm.total_budget_points}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      total_budget_points: event.target.value,
                    })
                  }
                  placeholder={t("Boş = sınırsız")}
                />
              </Field>
              <Field label={t("Doğrulama yöntemi")}>
                <select
                  value={taskForm.verification_method}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      verification_method: event.target.value,
                    })
                  }
                >
                                   <option value="server">
                    {t("Sunucu tarafından")}
                  </option>

                  <option value="session">
                    {t("Sayfa oturumuyla")}
                  </option>

                  <option value="code">
                    {t("Kampanya koduyla")}
                  </option>


                  <option value="user">
                    {t("Kullanıcı tamamlamasıyla")}
                  </option>
                </select>
              </Field>
              <Field label={t("Hedef kitle")}>
                <select
                  value={taskForm.target_type}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      target_type: event.target.value,
                    })
                  }
                >
                  {TARGET_TYPES.map((target) => (
                    <option key={target.value} value={target.value}>
                      {t(target.label)}
                    </option>
                  ))}
                </select>
              </Field>
              {taskForm.target_type !== "all" && (
                <Field label={t("Hedef değer")}>
                  <input
                    value={taskForm.target_value}
                    onChange={(event) =>
                      setTaskForm({
                        ...taskForm,
                        target_value: event.target.value,
                      })
                    }
                    placeholder={t(
                      "Kurum, ülke, şehir veya grup değeri"
                    )}
                  />
                </Field>
              )}
              <Field label={t("Başlangıç tarihi")}>
                <input
                  type="datetime-local"
                  value={taskForm.start_at}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      start_at: event.target.value,
                    })
                  }
                />
              </Field>
              <Field label={t("Bitiş tarihi")}>
                <input
                  type="datetime-local"
                  value={taskForm.end_at}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      end_at: event.target.value,
                    })
                  }
                />
              </Field>


              <Field
                label={t("Hedef bağlantı")}
                wide
                required={
                  taskForm.type ===
                  "content_read"
                }
              >
                <input
                  type="url"
                  value={
                    taskForm.destination_url
                  }
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      destination_url:
                        event.target.value,
                    })
                  }
                  placeholder="https://site.com/hakkimizda"
                  required={
                    taskForm.type ===
                    "content_read"
                  }
                />
              </Field>

              {taskForm.type ===
                "content_read" && (
                <Field
                  label={t(
                    "Sayfada kalma süresi (saniye)"
                  )}
                >
                  <input
                    type="number"
                    min="10"
                    max="600"
                    value={
                      taskForm
                        .content_min_seconds
                    }
                    onChange={(event) =>
                      setTaskForm({
                        ...taskForm,
                        content_min_seconds:
                          event.target.value,
                      })
                    }
                    required
                  />
                </Field>
              )}



              {["instagram_code", "website_code"].includes(taskForm.type) && (
                <>
                  <Field
                    label={
                      t(editor.id
                        ? "Yeni kampanya kodu (isteğe bağlı)"
                        : "Kampanya kodu")
                    }
                    required={!editor.id}
                  >
                    <input
                      value={taskForm.campaign_code}
                      onChange={(event) =>
                        setTaskForm({
                          ...taskForm,
                          campaign_code: event.target.value,
                        })
                      }
                      required={!editor.id}
                    />
                  </Field>
                  <Field label={t("Kullanıcıya sorulacak metin")}>
                    <input
                      value={taskForm.question}
                      onChange={(event) =>
                        setTaskForm({
                          ...taskForm,
                          question: event.target.value,
                        })
                      }
                      placeholder={t(
                        "Instagram paylaşımındaki kodu yazın"
                      )}
                    />
                  </Field>
                </>
              )}
              <Field label={t("Başarı mesajı")} wide>
                <input
                  value={taskForm.success_message}
                  onChange={(event) =>
                    setTaskForm({
                      ...taskForm,
                      success_message: event.target.value,
                    })
                  }
                  maxLength={1000}
                />
              </Field>
            </div>

            <div className="mp-toggle-grid">
              <InlineToggle
                label={t("Yalnızca bir kez tamamlanabilir")}
                checked={taskForm.first_time_only}
                onChange={(checked) =>
                  setTaskForm({ ...taskForm, first_time_only: checked })
                }
              />
              <InlineToggle
                label={t("Telefon doğrulaması gerekli")}
                checked={taskForm.requires_phone_verification}
                onChange={(checked) =>
                  setTaskForm({
                    ...taskForm,
                    requires_phone_verification: checked,
                  })
                }
              />
              <InlineToggle
                label={t("Görev aktif")}
                checked={taskForm.active}
                onChange={(checked) =>
                  setTaskForm({ ...taskForm, active: checked })
                }
              />
            </div>

                      <ModalFooter
              onCancel={() =>
                setEditor(null)
              }
              loading={loading}
              submitLabel={t(
                isSuperAdmin
                  ? (
                      editor.id
                        ? "Görevi Güncelle"
                        : "Görevi Oluştur"
                    )
                  : (
                      editor.id
                        ? "Değişiklikleri Onaya Gönder"
                        : "Görevi Onaya Gönder"
                    )
              )}
            />
          </form>
        </Modal>
      )}

      {isSuperAdmin && editor?.type === "campaign" && (
        <Modal
          title={
            t(editor.id
              ? "Sponsor Videosunu Düzenle"
              : "Yeni Sponsor Videosu")
          }
          subtitle={t(
            "Video süresini, ödülünü ve kampanya bütçesini tanımlayın."
          )}
          onClose={() => setEditor(null)}
        >
          <form onSubmit={saveCampaign}>
            <div className="mp-form-grid">
              <Field label={t("Kampanya başlığı")} wide required>
                <input
                  value={campaignForm.title}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      title: event.target.value,
                    })
                  }
                  maxLength={180}
                  required
                />
              </Field>
              <Field label={t("Sponsor/firma adı")}>
                <input
                  value={campaignForm.sponsor_name}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      sponsor_name: event.target.value,
                    })
                  }
                  maxLength={180}
                />
              </Field>
              <Field label={t("Sağlayıcı")}>
                <select
                  value={campaignForm.provider}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      provider: event.target.value,
                    })
                  }
                >
                  <option value="internal">
                    {t("MesYat sponsor videosu")}
                  </option>
                  <option value="admob">{t("AdMob (SSV gerekli)")}</option>
                </select>
              </Field>
              <Field label={t("Video bağlantısı")} wide required>
                <input
                  type="url"
                  value={campaignForm.video_url}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      video_url: event.target.value,
                    })
                  }
                  placeholder="https://..."
                  required={campaignForm.provider === "internal"}
                />
              </Field>
              <Field label={t("Kapak resmi bağlantısı")} wide>
                <input
                  type="url"
                  value={campaignForm.thumbnail_url}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      thumbnail_url: event.target.value,
                    })
                  }
                  placeholder="https://..."
                />
              </Field>



                  <Field
                label={t("Video süresi (saniye)")}
                required
              >
                <input
                  type="number"
                  min="5"
                  max="60"
                  value={campaignForm.duration_seconds}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      duration_seconds:
                        event.target.value,
                    })
                  }
                  required
                />
              </Field>




              <Field label={t("Tamamlama oranı (%)")} required>
                <input
                  type="number"
                  min="90"
                  max="100"
                  value={campaignForm.completion_percent}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      completion_percent: event.target.value,
                    })
                  }
                  required
                />
              </Field>
              <Field label={t("Video ödülü")} required>
                <input
                  type="number"
                  min="1"
                  value={campaignForm.reward_points}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      reward_points: event.target.value,
                    })
                  }
                  required
                />
              </Field>
              <Field label={t("Günlük izleme hakkı")}>
                <input
                  type="number"
                  min="1"
                  value={campaignForm.daily_view_limit}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      daily_view_limit: event.target.value,
                    })
                  }
                />
              </Field>
              <Field label={t("Toplam izlenme sınırı")}>
                <input
                  type="number"
                  min="1"
                  value={campaignForm.total_view_limit}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      total_view_limit: event.target.value,
                    })
                  }
                  placeholder={t("Boş = sınırsız")}
                />
              </Field>



                   <Field label={t("Toplam puan bütçesi")}>
                <input
                  type="number"
                  min="1"
                  value={campaignForm.budget_points}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      budget_points:
                        event.target.value,
                    })
                  }
                  placeholder={t("Boş = sınırsız")}
                />
              </Field>

              <Field label={t("Reklam kategorisi")}>
                <input
                  value={campaignForm.ad_category}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      ad_category:
                        event.target.value,
                    })
                  }
                  maxLength={80}
                  placeholder="general"
                />
              </Field>

              <Field label={t("Minimum yaş")}>
                <input
                  type="number"
                  min="13"
                  max="100"
                  value={campaignForm.target_min_age}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      target_min_age:
                        event.target.value,
                    })
                  }
                  placeholder="13"
                />
              </Field>

              <Field label={t("Maksimum yaş")}>
                <input
                  type="number"
                  min="13"
                  max="100"
                  value={campaignForm.target_max_age}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      target_max_age:
                        event.target.value,
                    })
                  }
                  placeholder="100"
                />
              </Field>

              <Field
                label={t("Cinsiyet hedefi")}
                wide
              >
                <input
                  value={campaignForm.target_genders}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      target_genders:
                        event.target.value,
                    })
                  }
                  placeholder="all, female, male"
                />
              </Field>

              <Field
                label={t("Sektör hedefleri")}
                wide
              >
                <input
                  value={campaignForm.target_sectors}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      target_sectors:
                        event.target.value,
                    })
                  }
                  placeholder="kuaför, restoran, eğitim"
                />
              </Field>

              <Field
                label={t("Dil hedefleri")}
                wide
              >
                <input
                  value={campaignForm.target_languages}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      target_languages:
                        event.target.value,
                    })
                  }
                  placeholder="tr, en, de"
                />
              </Field>

              <Field label={t("İzleme kredi bedeli")}>
                <input
                  type="number"
                  min="0"
                  step="1"
                  value={campaignForm.view_credit_cost}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      view_credit_cost:
                        event.target.value,
                    })
                  }
                />
              </Field>

              <Field label={t("Tıklama kredi bedeli")}>
                <input
                  type="number"
                  min="0"
                  step="1"
                  value={campaignForm.click_credit_cost}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      click_credit_cost:
                        event.target.value,
                    })
                  }
                />
              </Field>

              <Field label={t("Vitrin teklif kredisi")}>
                <input
                  type="number"
                  min="0"
                  step="1"
                  value={
                    campaignForm.showcase_bid_credits
                  }
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      showcase_bid_credits:
                        event.target.value,
                    })
                  }
                />
              </Field>

              <Field label={t("Hedef kitle")}>




                <select
                  value={campaignForm.target_type}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      target_type: event.target.value,
                    })
                  }
                >
                  {TARGET_TYPES.map((target) => (
                    <option key={target.value} value={target.value}>
                      {t(target.label)}
                    </option>
                  ))}
                </select>
              </Field>
              {campaignForm.target_type !== "all" && (
                <Field label={t("Hedef değer")}>
                  <input
                    value={campaignForm.target_value}
                    onChange={(event) =>
                      setCampaignForm({
                        ...campaignForm,
                        target_value: event.target.value,
                      })
                    }
                  />
                </Field>
              )}
              <Field label={t("Başlangıç tarihi")}>
                <input
                  type="datetime-local"
                  value={campaignForm.start_at}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      start_at: event.target.value,
                    })
                  }
                />
              </Field>
              <Field label={t("Bitiş tarihi")}>
                <input
                  type="datetime-local"
                  value={campaignForm.end_at}
                  onChange={(event) =>
                    setCampaignForm({
                      ...campaignForm,
                      end_at: event.target.value,
                    })
                  }
                />
              </Field>
            </div>
            <div className="mp-toggle-grid">
              <InlineToggle
                label={t("Sponsor kampanyası aktif")}
                checked={campaignForm.active}
                onChange={(checked) =>
                  setCampaignForm({ ...campaignForm, active: checked })
                }
              />
            </div>
            <ModalFooter
              onCancel={() => setEditor(null)}
              loading={loading}
              submitLabel={
                t(
                  editor.id
                    ? "Kampanyayı Güncelle"
                    : "Kampanyayı Oluştur"
                )
              }
            />
          </form>
        </Modal>
      )}

      {editor?.type === "discount" && (
        <Modal
          title={t(
            editor.id
              ? "İndirimi Düzenle"
              : "Yeni Marketplace İndirimi"
          )}
          subtitle={t(
            "MesPuan kullanım koşullarını, indirim değerini ve kampanya stoğunu belirleyin."
          )}
          onClose={() => setEditor(null)}
        >
          <form onSubmit={saveDiscount}>
            <div className="mp-form-grid">
              <Field label={t("İndirim başlığı")} wide required>
                <input
                  value={discountForm.title}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      title: event.target.value,
                    })
                  }
                  maxLength={180}
                  required
                />
              </Field>
              <Field label={t("Ürün/Hizmet adı")} required>
                <input
                  value={discountForm.product_name}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      product_name: event.target.value,
                    })
                  }
                  maxLength={180}
                  required
                />
              </Field>
              <Field label={t("Ürün referansı")}>
                <input
                  value={discountForm.product_id}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      product_id: event.target.value,
                    })
                  }
                  maxLength={120}
                />
              </Field>
              <Field label={t("Gerekli MesPuan")} required>
                <input
                  type="number"
                  min="1"
                  value={discountForm.required_points}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      required_points: event.target.value,
                    })
                  }
                  required
                />
              </Field>
              <Field label={t("İndirim türü")} required>
                <select
                  value={discountForm.discount_type}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      discount_type: event.target.value,
                    })
                  }
                >
                  <option value="fixed">{t("Sabit tutar")}</option>
                  <option value="percentage">{t("Yüzde")}</option>
                </select>
              </Field>
              <Field label={t("İndirim değeri")} required>
                <input
                  type="number"
                  min="0.01"
                  step="0.01"
                  value={discountForm.discount_value}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      discount_value: event.target.value,
                    })
                  }
                  required
                />
              </Field>
              <Field label={t("Para birimi")} required>
                <input
                  value={discountForm.currency}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      currency: event.target.value
                        .toUpperCase()
                        .slice(0, 3),
                    })
                  }
                  maxLength={3}
                  required
                />
              </Field>
              <Field label={t("Azami indirim oranı")} required>
                <input
                  type="number"
                  min="1"
                  max="25"
                  step="0.01"
                  value={discountForm.max_discount_percent}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      max_discount_percent: event.target.value,
                    })
                  }
                  required
                />
              </Field>
              <Field label={t("Kampanya stoğu")}>
                <input
                  type="number"
                  min="1"
                  value={discountForm.campaign_stock}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      campaign_stock: event.target.value,
                    })
                  }
                  placeholder={t("Boş = sınırsız")}
                />
              </Field>
              <Field label={t("Kullanıcı başı limit")} required>
                <input
                  type="number"
                  min="1"
                  value={discountForm.per_user_limit}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      per_user_limit: event.target.value,
                    })
                  }
                  required
                />
              </Field>
              <Field label={t("Başlangıç tarihi")}>
                <input
                  type="datetime-local"
                  value={discountForm.start_at}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      start_at: event.target.value,
                    })
                  }
                />
              </Field>
              <Field label={t("Bitiş tarihi")}>
                <input
                  type="datetime-local"
                  value={discountForm.end_at}
                  onChange={(event) =>
                    setDiscountForm({
                      ...discountForm,
                      end_at: event.target.value,
                    })
                  }
                />
              </Field>
            </div>
            <div className="mp-toggle-grid">
              <InlineToggle
                label={t("İndirim aktif")}
                checked={discountForm.active}
                onChange={(checked) =>
                  setDiscountForm({
                    ...discountForm,
                    active: checked,
                  })
                }
              />
            </div>
            <ModalFooter
              onCancel={() => setEditor(null)}
              loading={loading}
              submitLabel={t(
                editor.id
                  ? "İndirimi Güncelle"
                  : "İndirimi Oluştur"
              )}
            />
          </form>
        </Modal>
      )}

      {actionDialog && (
        <Modal
          title={
            t(actionDialog.action === "adjust"
              ? "Cüzdan Düzeltmesi"
              : actionDialog.action === "freeze"
              ? "Cüzdanı Dondur"
              : "Cüzdanı Aktifleştir")
          }
          subtitle={
            actionDialog.wallet.user_name ||
            `${t("Kullanıcı")} #${actionDialog.wallet.user_id}`
          }
          onClose={() => setActionDialog(null)}
          small
        >
          <div className="mp-form-grid">
            {actionDialog.action === "adjust" && (
              <>
                <Field label={t("Puan miktarı")} wide required>
                  <input
                    type="number"
                    value={actionDialog.amount}
                    onChange={(event) =>
                      setActionDialog({
                        ...actionDialog,
                        amount: event.target.value,
                      })
                    }
                    placeholder="+100 veya -50"
                  />
                </Field>
                <Field label={t("Referans")} wide>
                  <input
                    value={actionDialog.reference}
                    onChange={(event) =>
                      setActionDialog({
                        ...actionDialog,
                        reference: event.target.value,
                      })
                    }
                    placeholder={t("İsteğe bağlı işlem referansı")}
                  />
                </Field>
              </>
            )}
            {actionDialog.action !== "unfreeze" && (
              <Field label={t("İşlem gerekçesi")} wide required>
                <textarea
                  rows={4}
                  value={actionDialog.reason}
                  onChange={(event) =>
                    setActionDialog({
                      ...actionDialog,
                      reason: event.target.value,
                    })
                  }
                  placeholder={t(
                    "Denetim kaydı için ayrıntılı gerekçe yazın"
                  )}
                />
              </Field>
            )}
          </div>
          <div className="mp-modal-footer">
            <button
              type="button"
              className="mp-btn mp-btn-secondary"
              onClick={() => setActionDialog(null)}
            >
              {t("Vazgeç")}
            </button>
            <button
              type="button"
              className="mp-btn mp-btn-primary"
              onClick={executeWalletAction}
              disabled={loading}
            >
              {loading ? t("İşleniyor...") : t("İşlemi Onayla")}
            </button>
          </div>
        </Modal>
      )}
    </div>
    </I18nContext.Provider>
  );
}

function PageHeader({ title, description, action }) {
  return (
    <div className="mp-page-header">
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}

function PanelTitle({ title, description }) {
  return (
    <div className="mp-panel-title">
      <div>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
}

function StatCard({ label, value, suffix, tone }) {
  return (
    <article className={cx("mp-stat-card", `tone-${tone}`)}>
      <span className="mp-stat-icon">MP</span>
      <div>
        <span>{label}</span>
        <strong>
          {value} {suffix && <small>{suffix}</small>}
        </strong>
      </div>
    </article>
  );
}

function ActivityChart({ items }) {
  const { language, t } = useI18n();
  if (!items.length) {
    return (
      <EmptyState
        title={t("Henüz hareket verisi yok")}
        text={t("MesPuan kazanıldığında günlük grafik burada oluşur.")}
      />
    );
  }
  const max = Math.max(
    1,
    ...items.flatMap((item) => [
      Number(item.earned || 0),
      Number(item.spent || 0),
    ])
  );

  return (
    <div className="mp-chart">
      <div className="mp-chart-legend">
        <span>
          <i className="earned" /> {t("Kazanılan")}
        </span>
        <span>
          <i className="spent" /> {t("Kullanılan")}
        </span>
      </div>
      <div className="mp-chart-bars">
        {items.map((item) => (
          <div className="mp-chart-day" key={item.date}>
            <div className="mp-bars">
              <i
                className="earned"
                style={{
                  height: `${Math.max(
                    4,
                    (Number(item.earned || 0) / max) * 150
                  )}px`,
                }}
                title={`${t("Kazanılan")}: ${formatNumber(
                  item.earned
                )} MP`}
              />
              <i
                className="spent"
                style={{
                  height: `${Math.max(
                    4,
                    (Number(item.spent || 0) / max) * 150
                  )}px`,
                }}
                title={`${t("Kullanılan")}: ${formatNumber(
                  item.spent
                )} MP`}
              />
            </div>
            <span>
              {new Intl.DateTimeFormat(
                language === "de"
                  ? "de-DE"
                  : language === "en"
                  ? "en-GB"
                  : "tr-TR",
                {
                weekday: "short",
                }
              ).format(new Date(`${item.date}T12:00:00`))}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function FilterBar({
  children,
  onSubmit,
  searchValue,
  onSearch,
}) {
  const { t } = useI18n();
  return (
    <form
      className="mp-filter-bar"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <div className="mp-search">
        <span>{t("ARA")}</span>
        <input
          value={searchValue}
          onChange={(event) => onSearch(event.target.value)}
          placeholder={t("Başlık, kullanıcı veya işlem ara...")}
        />
      </div>
      {children}
      <button type="submit" className="mp-btn mp-btn-primary">
        {t("Filtrele")}
      </button>
    </form>
  );
}

function StatusBadge({ status }) {
  const { t } = useI18n();
  return (
    <span className={cx("mp-status", `status-${status || "unknown"}`)}>
      {t(statusLabel(status))}
    </span>
  );
}

function RowActions({ onEdit, onDelete }) {
  const { t } = useI18n();
  return (
    <div className="mp-inline-actions">
      <button type="button" onClick={onEdit}>
        {t("Düzenle")}
      </button>
      <button type="button" className="is-danger" onClick={onDelete}>
        {t("Arşivle")}
      </button>
    </div>
  );
}

function Pagination({ meta, onChange }) {
  const { t } = useI18n();
  const page = Number(meta?.page || 1);
  const totalPages = Number(meta?.totalPages || 1);
  if (totalPages <= 1) return null;

  return (
    <div className="mp-pagination">
      <span>
        {t("Sayfa")} {page} / {totalPages} · {formatNumber(meta?.total)}{" "}
        {t("kayıt")}
      </span>
      <div>
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          {t("Önceki")}
        </button>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
        >
          {t("Sonraki")}
        </button>
      </div>
    </div>
  );
}

function EmptyState({ title, text }) {
  return (
    <div className="mp-empty">
      <span>MP</span>
      <strong>{title}</strong>
      <p>{text}</p>
    </div>
  );
}

function Modal({ title, subtitle, onClose, children, small = false }) {
  const { t } = useI18n();
  useEffect(() => {
    function onKeyDown(event) {
      if (event.key === "Escape") onClose();
    }
    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="mp-modal-backdrop" role="presentation">
      <div
        className={cx("mp-modal", small && "is-small")}
        role="dialog"
        aria-modal="true"
      >
        <div className="mp-modal-header">
          <div>
            <h3>{title}</h3>
            <p>{subtitle}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label={t("Kapat")}
          >
            ×
          </button>
        </div>
        <div className="mp-modal-content">{children}</div>
      </div>
    </div>
  );
}

function Field({ label, children, wide = false, required = false }) {
  return (
    <label className={cx("mp-field", wide && "is-wide")}>
      <span>
        {label} {required && <b>*</b>}
      </span>
      {children}
    </label>
  );
}

function ModalFooter({ onCancel, loading, submitLabel }) {
  const { t } = useI18n();
  return (
    <div className="mp-modal-footer">
      <button
        type="button"
        className="mp-btn mp-btn-secondary"
        onClick={onCancel}
      >
        {t("Vazgeç")}
      </button>
      <button
        type="submit"
        className="mp-btn mp-btn-primary"
        disabled={loading}
      >
        {loading ? t("Kaydediliyor...") : submitLabel}
      </button>
    </div>
  );
}

function InlineToggle({ label, checked, onChange }) {
  return (
    <label className="mp-inline-toggle">
      <input
        type="checkbox"
        checked={Boolean(checked)}
        onChange={(event) => onChange(event.target.checked)}
      />
      <i />
      <span>{label}</span>
    </label>
  );
}

function SettingsSection({ title, description, children }) {
  return (
    <section className="mp-panel mp-settings-section">
      <PanelTitle title={title} description={description} />
      <div className="mp-settings-grid">{children}</div>
    </section>
  );
}

function TextSetting({ label, value, maxLength, onChange }) {
  return (
    <label className="mp-text-setting">
      <span>{label}</span>
      <input
        value={value ?? ""}
        maxLength={maxLength}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
}

function NumberSetting({
  label,
  value,
  suffix,
  onChange,
  min = 0,
  max,
}) {
  return (
    <label className="mp-number-setting">
      <span>{label}</span>
      <div>
        <input
          type="number"
          min={min}
          max={max}
          value={value ?? 0}
          onChange={(event) => onChange(Number(event.target.value))}
        />
        <b>{suffix}</b>
      </div>
    </label>
  );
}

function ToggleSetting({
  label,
  description,
  checked,
  onChange,
}) {
  return (
    <label className="mp-toggle-setting">
      <div>
        <strong>{label}</strong>
        <span>{description}</span>
      </div>
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      <i />
    </label>
  );
}

const STYLES = `
  :root {
    --mp-blue: #0b4d8b;
    --mp-blue-dark: #073866;
    --mp-blue-soft: #eaf3fb;
    --mp-orange: #f58220;
    --mp-ink: #132238;
    --mp-muted: #64748b;
    --mp-line: #dfe8f1;
    --mp-bg: #f3f7fb;
    --mp-white: #ffffff;
    --mp-green: #15803d;
    --mp-red: #b42318;
    --mp-shadow: 0 12px 34px rgba(11, 77, 139, 0.09);
  }

  .mp-admin {
    min-height: 100vh;
    background: var(--mp-bg);
    color: var(--mp-ink);
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
      "Segoe UI", sans-serif;
  }

  .mp-admin * { box-sizing: border-box; }
  .mp-admin button, .mp-admin input, .mp-admin select, .mp-admin textarea {
    font: inherit;
  }
  .mp-admin button { cursor: pointer; }

  .mp-hero {
    min-height: 188px;
    padding: 34px clamp(22px, 4vw, 64px);
    color: #fff;
    background:
      radial-gradient(circle at 80% 20%, rgba(245, 130, 32, .28), transparent 24%),
      linear-gradient(125deg, #073866 0%, #0b4d8b 62%, #1678c8 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 28px;
  }
  .mp-kicker {
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 1.7px;
    color: #ffbd85;
    margin-bottom: 10px;
  }
  .mp-hero h1 { margin: 0; font-size: clamp(28px, 4vw, 42px); letter-spacing: -.7px; }
  .mp-hero p { margin: 10px 0 0; max-width: 720px; color: #d8e8f5; line-height: 1.55; }
  .mp-hero-actions { display: flex; align-items: flex-end; gap: 10px; flex-wrap: wrap; justify-content: flex-end; }
  .mp-language { display: grid; gap: 5px; }
  .mp-language > span { color: #ffbd85; font-size: 10px; font-weight: 900; letter-spacing: .8px; }
  .mp-language select {
    width: 132px; height: 42px; border: 1px solid rgba(255,255,255,.28);
    background: rgba(255,255,255,.12); border-radius: 11px; color: #fff; padding: 0 11px; outline: none;
  }
  .mp-language option { color: #132238; background: #fff; }
  .mp-scope { display: grid; gap: 5px; }
  .mp-scope span { color: #d8e8f5; font-size: 10px; font-weight: 800; }
  .mp-scope input {
    width: 170px; height: 42px; border: 1px solid rgba(255,255,255,.28);
    background: rgba(255,255,255,.12); border-radius: 11px; color: #fff; padding: 0 12px;
  }
  .mp-scope input::placeholder { color: #bfd4e6; }
  .mp-scope-badge {
    height: 42px; display: flex; align-items: center; gap: 8px; border-radius: 11px;
    background: rgba(255,255,255,.12); border: 1px solid rgba(255,255,255,.25); padding: 0 13px;
    font-size: 12px;
  }

  .mp-layout {
    width: min(1600px, 100%);
    margin: 0 auto;
    display: grid;
    grid-template-columns: 250px minmax(0, 1fr);
    gap: 24px;
    padding: 24px;
  }

  .mp-sidebar {
    align-self: start;
    position: sticky;
    top: 20px;
    background: #fff;
    border: 1px solid var(--mp-line);
    border-radius: 22px;
    padding: 16px;
    box-shadow: var(--mp-shadow);
  }
  .mp-brand-card { display: flex; gap: 11px; align-items: center; padding: 5px 5px 17px; border-bottom: 1px solid var(--mp-line); }
  .mp-brand-mark {
    width: 46px; height: 46px; display: grid; place-items: center; border-radius: 14px;
    background: linear-gradient(135deg, var(--mp-blue), #1678c8); color: #fff; font-weight: 950;
    box-shadow: 0 8px 18px rgba(11,77,139,.23);
  }
  .mp-brand-card strong { display: block; font-size: 14px; }
  .mp-brand-card span { display: block; font-size: 9.5px; color: var(--mp-muted); margin-top: 2px; }
  .mp-sidebar nav { display: grid; gap: 6px; margin-top: 14px; }
  .mp-nav-item {
    width: 100%; border: 0; background: transparent; border-radius: 13px; padding: 10px;
    display: flex; align-items: center; gap: 10px; color: #40516a; font-size: 12px; font-weight: 750;
    text-align: left; transition: .18s ease;
  }
  .mp-nav-item:hover { background: #f1f6fa; color: var(--mp-blue); }
  .mp-nav-item.is-active { color: #fff; background: linear-gradient(100deg, var(--mp-blue-dark), var(--mp-blue)); box-shadow: 0 8px 20px rgba(11,77,139,.18); }
  .mp-nav-mark {
    flex: 0 0 30px; height: 30px; border-radius: 9px; display: grid; place-items: center;
    background: var(--mp-blue-soft); color: var(--mp-blue); font-size: 9px; font-weight: 950;
  }
  .mp-nav-item.is-active .mp-nav-mark { background: rgba(255,255,255,.16); color: #fff; }
  .mp-security-note { margin-top: 18px; padding: 14px; border-radius: 15px; background: #f8fafc; border: 1px solid var(--mp-line); }
  .mp-security-note strong { font-size: 11px; color: var(--mp-blue); }
  .mp-security-note p { margin: 6px 0 0; color: var(--mp-muted); font-size: 9px; line-height: 1.5; }

  .mp-content { min-width: 0; padding-bottom: 50px; }
  .mp-page-header { display: flex; justify-content: space-between; gap: 18px; align-items: center; margin: 4px 0 18px; }
  .mp-page-header h2 { margin: 0; font-size: 25px; letter-spacing: -.35px; }
  .mp-page-header p { margin: 6px 0 0; color: var(--mp-muted); font-size: 12px; }

  .mp-btn {
    min-height: 42px; border: 0; border-radius: 11px; padding: 0 16px; font-weight: 850; font-size: 11px;
    display: inline-flex; align-items: center; justify-content: center; transition: .18s ease;
  }
  .mp-btn:disabled { opacity: .55; cursor: not-allowed; }
  .mp-btn-primary { color: #fff; background: linear-gradient(100deg, var(--mp-blue), #1678c8); box-shadow: 0 7px 17px rgba(11,77,139,.17); }
  .mp-btn-primary:hover:not(:disabled) { transform: translateY(-1px); }
  .mp-btn-secondary { color: var(--mp-ink); background: #eef3f7; }
  .mp-btn-light { color: var(--mp-blue); background: #fff; }

  .mp-stat-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 13px; }
  .mp-stat-card {
    min-height: 116px; background: #fff; border: 1px solid var(--mp-line); border-radius: 19px; padding: 18px;
    display: flex; align-items: center; gap: 14px; box-shadow: var(--mp-shadow); position: relative; overflow: hidden;
  }
  .mp-stat-card::after { content: ""; position: absolute; right: -25px; top: -25px; width: 85px; height: 85px; border-radius: 50%; background: currentColor; opacity: .05; }
  .mp-stat-icon { width: 44px; height: 44px; border-radius: 14px; display: grid; place-items: center; font-size: 10px; font-weight: 950; background: currentColor; color: transparent; position: relative; }
  .mp-stat-icon::after { content: "MP"; color: #fff; position: absolute; }
  .mp-stat-card > div > span { display: block; color: var(--mp-muted); font-size: 10px; font-weight: 700; }
  .mp-stat-card > div > strong { display: block; margin-top: 5px; font-size: 23px; letter-spacing: -.4px; }
  .mp-stat-card small { font-size: 10px; color: var(--mp-muted); }
  .tone-blue { color: var(--mp-blue); }
  .tone-cyan { color: #067f87; }
  .tone-orange { color: var(--mp-orange); }
  .tone-green { color: var(--mp-green); }
  .tone-red { color: var(--mp-red); }

  .mp-two-column { display: grid; grid-template-columns: 1.15fr .85fr; gap: 14px; margin-top: 14px; }
  .mp-panel { background: #fff; border: 1px solid var(--mp-line); border-radius: 19px; box-shadow: var(--mp-shadow); padding: 18px; }
  .mp-panel-title { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
  .mp-panel-title h3 { margin: 0; font-size: 14px; }
  .mp-panel-title p { margin: 4px 0 0; color: var(--mp-muted); font-size: 9.5px; }
  .mp-compact-list { display: grid; }
  .mp-rank-row { display: grid; grid-template-columns: 32px minmax(0, 1fr) auto; gap: 10px; align-items: center; padding: 11px 0; border-bottom: 1px solid #edf2f6; }
  .mp-rank-row:last-child { border-bottom: 0; }
  .mp-rank { width: 28px; height: 28px; display: grid; place-items: center; border-radius: 9px; background: var(--mp-blue-soft); color: var(--mp-blue); font-weight: 900; font-size: 10px; }
  .mp-rank-row strong { display: block; font-size: 11px; }
  .mp-rank-row span { display: block; color: var(--mp-muted); font-size: 8.5px; margin-top: 2px; }
  .mp-rank-value { text-align: right; }

  .mp-chart { min-height: 230px; }
  .mp-chart-legend { display: flex; justify-content: flex-end; gap: 14px; color: var(--mp-muted); font-size: 9px; }
  .mp-chart-legend span { display: flex; align-items: center; gap: 5px; }
  .mp-chart-legend i { width: 8px; height: 8px; border-radius: 3px; }
  .mp-chart .earned { background: var(--mp-blue); }
  .mp-chart .spent { background: var(--mp-orange); }
  .mp-chart-bars { height: 190px; display: grid; grid-template-columns: repeat(7, 1fr); gap: 12px; align-items: end; padding: 20px 8px 0; border-bottom: 1px solid var(--mp-line); }
  .mp-chart-day { min-width: 0; text-align: center; }
  .mp-bars { height: 155px; display: flex; justify-content: center; align-items: end; gap: 4px; }
  .mp-bars i { width: min(14px, 35%); border-radius: 5px 5px 2px 2px; min-height: 4px; }
  .mp-chart-day > span { display: block; color: var(--mp-muted); font-size: 8.5px; margin-top: 8px; }

  .mp-filter-bar {
    display: flex; flex-wrap: wrap; gap: 9px; align-items: center; background: #fff; border: 1px solid var(--mp-line);
    border-radius: 16px; padding: 11px; margin-bottom: 13px; box-shadow: 0 5px 18px rgba(11,77,139,.05);
  }
  .mp-filter-bar input, .mp-filter-bar select {
    height: 40px; border: 1px solid var(--mp-line); border-radius: 10px; background: #fff; padding: 0 11px; color: var(--mp-ink); font-size: 10.5px; outline: none;
  }
  .mp-filter-bar input:focus, .mp-filter-bar select:focus { border-color: #73a7d4; box-shadow: 0 0 0 3px rgba(11,77,139,.08); }
  .mp-search { flex: 1 1 260px; display: flex; align-items: center; border: 1px solid var(--mp-line); border-radius: 10px; overflow: hidden; height: 40px; }
  .mp-search span { padding: 0 10px; font-size: 8px; font-weight: 950; color: var(--mp-blue); }
  .mp-search input { flex: 1; border: 0; height: 100%; min-width: 80px; }

  .mp-table-panel { padding: 0; overflow: hidden; }
  .mp-table-scroll { overflow-x: auto; }
  .mp-admin table { width: 100%; border-collapse: collapse; min-width: 850px; }
  .mp-admin th { padding: 13px 14px; text-align: left; background: #f8fafc; color: #66778d; border-bottom: 1px solid var(--mp-line); font-size: 8.5px; letter-spacing: .4px; text-transform: uppercase; }
  .mp-admin td { padding: 13px 14px; border-bottom: 1px solid #edf2f6; color: #3d4d63; font-size: 10.5px; vertical-align: middle; }
  .mp-admin tbody tr:hover { background: #fbfdff; }
  .mp-main-cell strong, .mp-user-cell strong { display: block; color: var(--mp-ink); font-size: 11px; }
  .mp-main-cell span, .mp-user-cell span { display: block; color: var(--mp-muted); font-size: 8.8px; margin-top: 3px; max-width: 330px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .mp-points, .mp-balance { color: var(--mp-blue); }
  .mp-amount-positive { color: var(--mp-green); }
  .mp-amount-negative { color: var(--mp-red); }
  .mp-user-cell { display: flex; align-items: center; gap: 9px; }
  .mp-avatar { flex: 0 0 34px; height: 34px; border-radius: 10px; display: grid !important; place-items: center; background: var(--mp-blue-soft); color: var(--mp-blue) !important; font-weight: 950; margin: 0 !important; }
  .mp-inline-actions { display: flex; justify-content: flex-end; gap: 6px; }
  .mp-inline-actions button, .mp-card-actions button, .mp-risk-actions button {
    border: 1px solid var(--mp-line); background: #fff; color: var(--mp-blue); border-radius: 8px; padding: 6px 9px; font-size: 8.5px; font-weight: 800;
  }
  .mp-inline-actions button:hover, .mp-card-actions button:hover { background: var(--mp-blue-soft); }
  .mp-inline-actions .is-danger, .mp-card-actions .is-danger, .mp-risk-actions .is-danger { color: var(--mp-red); border-color: #f2c7c3; }

  .mp-status { display: inline-flex; align-items: center; min-height: 23px; padding: 0 8px; border-radius: 20px; font-size: 8.5px; font-weight: 850; white-space: nowrap; }
  .status-active { color: #137a3a; background: #e9f7ee; }
  .status-inactive, .status-expired { color: #64748b; background: #eef2f6; }
  .status-scheduled { color: #98600d; background: #fff5dd; }


  .status-pending {
    color: #a6530d;
    background: #fff0e3;
  }

  .status-approval_pending {
    color: #92400e;
    background: #fef3c7;
  }

  .status-approval_rejected {
    color: #991b1b;
    background: #fee2e2;
  }

  .status-resolved {
    color: #137a3a;
    background: #e9f7ee;
  }

  .status-frozen, .status-blocked { color: var(--mp-red); background: #fff0ee; }

  .mp-pagination { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 13px 16px; color: var(--mp-muted); font-size: 9px; border-top: 1px solid var(--mp-line); }
  .mp-pagination div { display: flex; gap: 6px; }
  .mp-pagination button { border: 1px solid var(--mp-line); background: #fff; color: var(--mp-blue); border-radius: 8px; padding: 7px 10px; font-size: 9px; font-weight: 800; }
  .mp-pagination button:disabled { opacity: .4; cursor: not-allowed; }

  .mp-campaign-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; }
  .mp-campaign-card { background: #fff; border: 1px solid var(--mp-line); border-radius: 20px; overflow: hidden; box-shadow: var(--mp-shadow); }
  .mp-video-cover { height: 170px; position: relative; background: linear-gradient(135deg, var(--mp-blue-dark), #1678c8); overflow: hidden; }
  .mp-video-cover img { width: 100%; height: 100%; object-fit: cover; }
  .mp-video-placeholder { width: 100%; height: 100%; display: grid; place-items: center; color: rgba(255,255,255,.75); font-size: 31px; font-weight: 950; }
  .mp-reward-chip, .mp-duration-chip { position: absolute; bottom: 10px; border-radius: 20px; padding: 6px 9px; color: #fff; font-size: 9px; font-weight: 900; }
  .mp-reward-chip { left: 10px; background: var(--mp-orange); }
  .mp-duration-chip { right: 10px; background: rgba(8,26,44,.78); }
  .mp-campaign-body { padding: 15px; }
  .mp-card-title-row { display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; }
  .mp-card-title-row > div > strong { display: block; color: var(--mp-ink); font-size: 12px; }
  .mp-card-title-row > div > span { display: block; color: var(--mp-muted); font-size: 9px; margin-top: 4px; }
  .mp-mini-stats { display: grid; grid-template-columns: repeat(3, 1fr); margin: 15px 0; border: 1px solid var(--mp-line); border-radius: 12px; overflow: hidden; }
  .mp-mini-stats div { padding: 9px; text-align: center; border-right: 1px solid var(--mp-line); }
  .mp-mini-stats div:last-child { border-right: 0; }
  .mp-mini-stats span { display: block; color: var(--mp-muted); font-size: 7.5px; }
  .mp-mini-stats strong { display: block; color: var(--mp-ink); font-size: 11px; margin-top: 3px; }
  .mp-budget > div:first-child { display: flex; justify-content: space-between; gap: 10px; color: var(--mp-muted); font-size: 8.5px; }
  .mp-budget strong { color: var(--mp-ink); }
  .mp-progress { height: 6px; background: #e9eff5; border-radius: 10px; overflow: hidden; margin-top: 7px; }
  .mp-progress i { display: block; height: 100%; background: linear-gradient(90deg, var(--mp-blue), var(--mp-orange)); border-radius: inherit; }
  .mp-card-actions { display: flex; justify-content: flex-end; gap: 7px; margin-top: 15px; }

  .mp-discount-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; }
  .mp-discount-card {
    position: relative; overflow: hidden; background: #fff; border: 1px solid var(--mp-line);
    border-radius: 20px; box-shadow: var(--mp-shadow);
  }
  .mp-discount-card::before {
    content: ""; position: absolute; inset: 0 0 auto; height: 4px;
    background: linear-gradient(90deg, var(--mp-blue), var(--mp-orange));
  }
  .mp-discount-top { display: flex; justify-content: space-between; align-items: center; padding: 17px 17px 0; }
  .mp-discount-mark {
    width: 42px; height: 42px; display: grid; place-items: center; border-radius: 13px;
    color: #fff; background: linear-gradient(135deg, var(--mp-blue-dark), var(--mp-blue));
    box-shadow: 0 8px 18px rgba(11,77,139,.18); font-size: 10px; font-weight: 950;
  }
  .mp-discount-content { padding: 13px 17px 17px; }
  .mp-discount-product {
    display: block; min-height: 14px; color: var(--mp-orange); font-size: 8px;
    font-weight: 900; letter-spacing: .5px; text-transform: uppercase;
  }
  .mp-discount-content h3 { min-height: 34px; margin: 5px 0 12px; color: var(--mp-ink); font-size: 14px; line-height: 1.25; }
  .mp-discount-value { color: var(--mp-blue); font-size: 25px; font-weight: 950; letter-spacing: -.5px; }

  .mp-risk-list { display: grid; gap: 10px; }
  .mp-risk-card { display: grid; grid-template-columns: 68px minmax(0, 1fr) auto; gap: 14px; align-items: center; background: #fff; border: 1px solid var(--mp-line); border-radius: 17px; padding: 14px; box-shadow: var(--mp-shadow); }
  .mp-risk-score { width: 58px; height: 58px; display: grid; place-content: center; text-align: center; border-radius: 16px; color: #a6530d; background: #fff3e6; }
  .mp-risk-score.is-high { color: var(--mp-red); background: #fff0ee; }
  .mp-risk-score strong { font-size: 20px; line-height: 1; }
  .mp-risk-score span { font-size: 7px; margin-top: 3px; }
  .mp-risk-content p { margin: 8px 0; color: #58697f; font-size: 9.5px; line-height: 1.5; }
  .mp-risk-meta { display: flex; gap: 12px; flex-wrap: wrap; color: var(--mp-muted); font-size: 8px; }
  .mp-risk-actions { display: flex; gap: 7px; }

  .mp-settings-form { display: grid; gap: 13px; }
  .mp-settings-section { padding: 18px; }
  .mp-settings-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 11px; }
  .mp-number-setting, .mp-text-setting, .mp-toggle-setting { border: 1px solid var(--mp-line); border-radius: 13px; padding: 12px; }
  .mp-number-setting > span, .mp-text-setting > span { display: block; color: var(--mp-muted); font-size: 9px; font-weight: 800; margin-bottom: 7px; }
  .mp-text-setting input { width: 100%; height: 40px; border: 1px solid var(--mp-line); border-radius: 10px; padding: 0 10px; outline: none; font-weight: 800; color: var(--mp-ink); }
  .mp-text-setting input:focus { border-color: var(--mp-blue); box-shadow: 0 0 0 3px rgba(11, 77, 139, .08); }
  .mp-number-setting > div { display: flex; border: 1px solid var(--mp-line); border-radius: 10px; overflow: hidden; }
  .mp-number-setting input { min-width: 0; flex: 1; height: 38px; border: 0; padding: 0 10px; outline: none; font-weight: 800; color: var(--mp-ink); }
  .mp-number-setting b { display: grid; place-items: center; padding: 0 10px; background: #f6f9fc; color: var(--mp-blue); font-size: 9px; }
  .mp-toggle-setting { position: relative; display: flex; align-items: center; justify-content: space-between; gap: 12px; cursor: pointer; }
  .mp-toggle-setting strong { display: block; font-size: 10.5px; }
  .mp-toggle-setting span { display: block; color: var(--mp-muted); font-size: 8.5px; margin-top: 3px; }
  .mp-toggle-setting input { position: absolute; opacity: 0; }
  .mp-toggle-setting i { flex: 0 0 42px; height: 24px; border-radius: 20px; background: #cbd5e1; position: relative; transition: .18s; }
  .mp-toggle-setting i::after { content: ""; position: absolute; width: 18px; height: 18px; left: 3px; top: 3px; background: #fff; border-radius: 50%; box-shadow: 0 2px 7px rgba(0,0,0,.17); transition: .18s; }
  .mp-toggle-setting input:checked + i { background: var(--mp-blue); }
  .mp-toggle-setting input:checked + i::after { transform: translateX(18px); }
  .mp-locked-rules { padding: 14px 16px; border-radius: 14px; background: #fff7ed; border: 1px solid #fed7aa; }
  .mp-locked-rules strong { display: block; color: #9a4d0b; font-size: 10.5px; }
  .mp-locked-rules span { display: block; color: #a75c1c; font-size: 9px; margin-top: 4px; }
  .mp-form-footer { display: flex; justify-content: flex-end; }

  .mp-alert { display: flex; justify-content: space-between; gap: 14px; align-items: center; padding: 13px; border-radius: 13px; margin-bottom: 15px; }
  .mp-alert.is-error { color: #92241b; background: #fff0ee; border: 1px solid #f3c7c2; }
  .mp-alert strong, .mp-alert span { display: block; }
  .mp-alert strong { font-size: 10.5px; }
  .mp-alert span { font-size: 9px; margin-top: 3px; }
  .mp-alert button { border: 0; background: #fff; color: var(--mp-red); border-radius: 8px; padding: 7px 10px; font-size: 9px; font-weight: 800; }

  .mp-empty { padding: 34px 20px; text-align: center; }
  .mp-empty > span { width: 46px; height: 46px; display: grid; place-items: center; margin: 0 auto 10px; border-radius: 14px; color: var(--mp-blue); background: var(--mp-blue-soft); font-size: 10px; font-weight: 950; }
  .mp-empty strong { display: block; font-size: 12px; }
  .mp-empty p { margin: 5px auto 0; max-width: 380px; color: var(--mp-muted); font-size: 9px; line-height: 1.5; }

  .mp-toast {
    position: fixed;
    z-index: 2147483000;

    top: 76px;
    right: 18px;

    width: min(
      420px,
      calc(100vw - 36px)
    );

    max-width: 420px;

    display: flex;
    align-items: center;
    gap: 9px;

    background: #fff;
    color: var(--mp-ink);

    border: 1px solid var(--mp-line);
    border-radius: 13px;

    padding: 12px 13px;

    box-shadow:
      0 18px 45px
      rgba(8, 26, 44, 0.24);

    font-size: 10px;
    font-weight: 750;
    line-height: 1.45;
  }


  .mp-toast-dot { width: 9px; height: 9px; border-radius: 50%; background: var(--mp-green); }
  .mp-toast.is-error .mp-toast-dot { background: var(--mp-red); }
  .mp-toast button { margin-left: auto; border: 0; background: transparent; color: var(--mp-muted); font-size: 18px; }

  .mp-modal-backdrop { position: fixed; z-index: 1200; inset: 0; display: grid; place-items: center; padding: 18px; background: rgba(8,26,44,.62); backdrop-filter: blur(4px); }
  .mp-modal { width: min(880px, 100%); max-height: calc(100vh - 36px); overflow: hidden; background: #fff; border-radius: 22px; box-shadow: 0 25px 80px rgba(0,0,0,.32); }
  .mp-modal.is-small { width: min(560px, 100%); }
  .mp-modal-header { display: flex; justify-content: space-between; gap: 15px; align-items: flex-start; padding: 18px 20px; color: #fff; background: linear-gradient(115deg, var(--mp-blue-dark), var(--mp-blue)); }
  .mp-modal-header h3 { margin: 0; font-size: 17px; }
  .mp-modal-header p { margin: 5px 0 0; color: #d7e7f4; font-size: 9.5px; }
  .mp-modal-header button { border: 0; background: rgba(255,255,255,.13); color: #fff; width: 34px; height: 34px; border-radius: 10px; font-size: 22px; }
  .mp-modal-content { max-height: calc(100vh - 130px); overflow-y: auto; padding: 20px; }
  .mp-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
  .mp-field { display: grid; gap: 6px; }
  .mp-field.is-wide { grid-column: 1 / -1; }
  .mp-field > span { color: #52647a; font-size: 9px; font-weight: 850; }
  .mp-field > span b { color: var(--mp-red); }
  .mp-field input, .mp-field select, .mp-field textarea {
    width: 100%; border: 1px solid var(--mp-line); border-radius: 10px; background: #fff; color: var(--mp-ink); padding: 10px 11px; font-size: 10.5px; outline: none;
  }
  .mp-field input, .mp-field select { height: 41px; }
  .mp-field textarea { resize: vertical; min-height: 80px; }
  .mp-field input:focus, .mp-field select:focus, .mp-field textarea:focus { border-color: #73a7d4; box-shadow: 0 0 0 3px rgba(11,77,139,.08); }
  .mp-toggle-grid { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 14px; padding: 13px; border-radius: 13px; background: #f7fafc; border: 1px solid var(--mp-line); }
  .mp-inline-toggle { position: relative; display: flex; align-items: center; gap: 8px; cursor: pointer; color: #40516a; font-size: 9.5px; font-weight: 750; }
  .mp-inline-toggle input { position: absolute; opacity: 0; }
  .mp-inline-toggle i { width: 34px; height: 20px; border-radius: 20px; background: #cbd5e1; position: relative; transition: .18s; }
  .mp-inline-toggle i::after { content: ""; position: absolute; width: 14px; height: 14px; left: 3px; top: 3px; border-radius: 50%; background: #fff; transition: .18s; }
  .mp-inline-toggle input:checked + i { background: var(--mp-blue); }
  .mp-inline-toggle input:checked + i::after { transform: translateX(14px); }
  .mp-modal-footer { display: flex; justify-content: flex-end; gap: 8px; margin-top: 18px; padding-top: 15px; border-top: 1px solid var(--mp-line); }

  @media (max-width: 1180px) {
    .mp-campaign-grid, .mp-discount-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .mp-stat-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  }
  @media (max-width: 920px) {
    .mp-hero { align-items: flex-start; flex-direction: column; }
    .mp-hero-actions { justify-content: flex-start; }
    .mp-layout { grid-template-columns: 1fr; padding: 15px; }
    .mp-sidebar { position: static; overflow-x: auto; }
    .mp-brand-card, .mp-security-note { display: none; }
    .mp-sidebar nav { display: flex; margin: 0; min-width: max-content; }
    .mp-nav-item { width: auto; }
    .mp-two-column { grid-template-columns: 1fr; }
  }
  @media (max-width: 680px) {
    .mp-hero { min-height: auto; padding: 26px 18px; }
    .mp-hero-actions, .mp-language, .mp-language select, .mp-scope, .mp-scope input, .mp-hero-actions .mp-btn { width: 100%; }
    .mp-page-header { align-items: flex-start; flex-direction: column; }
    .mp-page-header > div:last-child, .mp-page-header .mp-btn { width: 100%; }
    .mp-stat-grid, .mp-campaign-grid, .mp-discount-grid, .mp-settings-grid, .mp-form-grid { grid-template-columns: 1fr; }
    .mp-field.is-wide { grid-column: auto; }
    .mp-filter-bar > select, .mp-filter-bar > input, .mp-filter-bar > .mp-btn { width: 100%; }
    .mp-risk-card { grid-template-columns: 58px minmax(0, 1fr); }
    .mp-risk-actions { grid-column: 1 / -1; justify-content: flex-end; }
    .mp-modal-backdrop { padding: 0; align-items: end; }
    .mp-modal { max-height: 96vh; border-radius: 22px 22px 0 0; }
  }
`;
